!(function (t, e) {
	"object" == typeof exports && "object" == typeof module
		? (module.exports = e())
		: "function" == typeof define && define.amd
			? define([], e)
			: "object" == typeof exports
				? (exports.Bootstrapper = e())
				: (t.Bootstrapper = e());
})(this, () =>
	(() => {
		var t = {
				32: (t, e, r) => {
					"use strict";
					r.d(e, {
						Ao: () => d,
						B0: () => s,
						BP: () => p,
						C4: () => n,
						Kh: () => a,
						Qe: () => f,
						S_: () => l,
						_v: () => y,
						bI: () => o,
						iK: () => g,
						jY: () => i,
						ml: () => m,
						sM: () => c,
						tn: () => u,
						x3: () => h,
						yX: () => b,
					});
					const o = 1280,
						n = { LEFT: 1, CENTER: 2, RIGHT: 3 },
						i = { MOBILE: "MOBILE", TABLET: "TABLET", DESKTOP: "DESKTOP", NONE: "-" },
						a = {
							STANDARD: 1,
							ASIAN: 2,
							AFRICAN: 3,
							PAPER: 4,
							ESPORT: 5,
							ESPORT_VIEW: 11,
							LATINO: 6,
							SIMPLE_EAST: 7,
							MODERN: 8,
							EUROPEAN: 9,
							BETSHOP: 10,
						},
						s = "/staticcontent",
						l = [
							"EuropeanView",
							"LatinoView",
							"AsianView",
							"ModernView",
							"Mobile",
							"ESport",
							"EsportView",
							"SimpleEast",
							"BetShop",
						],
						c = "SF-",
						p = "Betslip",
						u = "asian",
						f = "AsianView_mobile",
						d = "betslip",
						h = "v",
						y = ["EventWidget", "TopMatches", "Jackpot"],
						m = [
							"EuropeanView",
							"SimpleEast",
							"Mobile",
							"EsportView",
							"ModernView",
							"LatinoView",
							"LivePage",
							"TopMatches",
							"AsianView",
							"LandingWidgets",
							"asian-view",
						],
						g = [
							"LatinoView",
							"EuropeanView",
							"EsportView",
							"Mobile",
							"ModernView",
							"AsianView",
						],
						b = [
							"toggleStake",
							"updateUserBalance",
							"updateOddFormat",
							"chequeRedactOrder",
							"repeatTheBet",
							"loadExpressOfTheDay",
							"clearBetSlip",
							"openBetSlip",
							"closeBetSlip",
							"setSportTournamentMode",
							"updateTimeFormat",
							"openSystemCalculator",
							"setBetBuilderData",
							"switchView",
							"cancelBetBuilderEdit",
							"sportAppEventListener",
							"changeColors",
						];
				},
				644: (t, e, r) => {
					"use strict";
					r.d(e, {
						VX: () => c,
						W7: () => p,
						aR: () => l,
						bz: () => u,
						e9: () => a,
						fn: () => s,
						kW: () => i,
						lQ: () => o,
						nr: () => n,
					}),
						r(32);
					const o = () => {},
						n = () =>
							/Safari/.test(navigator.userAgent) &&
							/Apple Computer/.test(navigator.vendor);
					function i(t = "") {
						return t
							.replace(/([A-Z])([A-Z])/g, "$1-$2")
							.replace(/([a-z])([A-Z])/g, "$1-$2")
							.replace(/[\s_]+/g, "-")
							.toLowerCase();
					}
					const a = (t, e = "") => e.split(".").reduce((t, e) => (t ? t[e] : t), t),
						s = (t, e = "") =>
							e.split(".").reduce((t, e) => {
								let r = t && t[e];
								return (
									(r =
										r && "function" == typeof r && "object" == typeof t
											? r.bind(t)
											: r),
									r
								);
							}, t);
					function l(t, e, r = Function.prototype) {
						const o = t[e];
						if (!o) return null;
						const n = Object.create(Object.getPrototypeOf(o)),
							i = Object.keys(t);
						return (
							o.addEventListener("sportAppEventListener", ({ data: r }) => {
								i.filter((t) => t !== e).forEach((e) => {
									t[e].dispatch("sportAppEventListener", r);
								});
							}),
							Object.assign(n, o, {
								changeColors(e) {
									i.forEach((r) => {
										t[r].changeColors(e);
									});
								},
								destroy() {
									i.forEach((e) => {
										t[e].destroy();
									}),
										r();
								},
							}),
							i.forEach((r) => {
								e !== r && (n[r] = t[r]);
							}),
							n
						);
					}
					function c(t, e) {
						Object.entries(e).forEach(([e, r]) => {
							t.style[e] = r || null;
						});
					}
					function p(t = 10) {
						let e = "",
							r = 0;
						for (; r < t; )
							(e += "abcdefghijklmnopqrstuvwxyz0123456789".charAt(
								Math.floor(36 * Math.random())
							)),
								(r += 1);
						return e;
					}
					function u(t) {
						return (
							Math.max(600, window.innerHeight - t.getBoundingClientRect().top) + "px"
						);
					}
				},
				61: (t, e, r) => {
					"use strict";
					var o = r(375),
						n = r(629),
						i = n(o("String.prototype.indexOf"));
					t.exports = function (t, e) {
						var r = o(t, !!e);
						return "function" == typeof r && i(t, ".prototype.") > -1 ? n(r) : r;
					};
				},
				629: (t, e, r) => {
					"use strict";
					var o = r(989),
						n = r(375),
						i = r(259),
						a = r(277),
						s = n("%Function.prototype.apply%"),
						l = n("%Function.prototype.call%"),
						c = n("%Reflect.apply%", !0) || o.call(l, s),
						p = r(709),
						u = n("%Math.max%");
					t.exports = function (t) {
						if ("function" != typeof t) throw new a("a function is required");
						var e = c(o, l, arguments);
						return i(e, 1 + u(0, t.length - (arguments.length - 1)), !0);
					};
					var f = function () {
						return c(o, s, arguments);
					};
					p ? p(t.exports, "apply", { value: f }) : (t.exports.apply = f);
				},
				411: (t, e, r) => {
					"use strict";
					var o = r(709),
						n = r(430),
						i = r(277),
						a = r(553);
					t.exports = function (t, e, r) {
						if (!t || ("object" != typeof t && "function" != typeof t))
							throw new i("`obj` must be an object or a function`");
						if ("string" != typeof e && "symbol" != typeof e)
							throw new i("`property` must be a string or a symbol`");
						if (
							arguments.length > 3 &&
							"boolean" != typeof arguments[3] &&
							null !== arguments[3]
						)
							throw new i("`nonEnumerable`, if provided, must be a boolean or null");
						if (
							arguments.length > 4 &&
							"boolean" != typeof arguments[4] &&
							null !== arguments[4]
						)
							throw new i("`nonWritable`, if provided, must be a boolean or null");
						if (
							arguments.length > 5 &&
							"boolean" != typeof arguments[5] &&
							null !== arguments[5]
						)
							throw new i(
								"`nonConfigurable`, if provided, must be a boolean or null"
							);
						if (arguments.length > 6 && "boolean" != typeof arguments[6])
							throw new i("`loose`, if provided, must be a boolean");
						var s = arguments.length > 3 ? arguments[3] : null,
							l = arguments.length > 4 ? arguments[4] : null,
							c = arguments.length > 5 ? arguments[5] : null,
							p = arguments.length > 6 && arguments[6],
							u = !!a && a(t, e);
						if (o)
							o(t, e, {
								configurable: null === c && u ? u.configurable : !c,
								enumerable: null === s && u ? u.enumerable : !s,
								value: r,
								writable: null === l && u ? u.writable : !l,
							});
						else {
							if (!p && (s || l || c))
								throw new n(
									"This environment does not support defining a property as non-configurable, non-writable, or non-enumerable."
								);
							t[e] = r;
						}
					};
				},
				709: (t, e, r) => {
					"use strict";
					var o = r(375)("%Object.defineProperty%", !0) || !1;
					if (o)
						try {
							o({}, "a", { value: 1 });
						} catch (t) {
							o = !1;
						}
					t.exports = o;
				},
				123: (t) => {
					"use strict";
					t.exports = EvalError;
				},
				953: (t) => {
					"use strict";
					t.exports = Error;
				},
				780: (t) => {
					"use strict";
					t.exports = RangeError;
				},
				768: (t) => {
					"use strict";
					t.exports = ReferenceError;
				},
				430: (t) => {
					"use strict";
					t.exports = SyntaxError;
				},
				277: (t) => {
					"use strict";
					t.exports = TypeError;
				},
				619: (t) => {
					"use strict";
					t.exports = URIError;
				},
				307: (t) => {
					"use strict";
					var e = Object.prototype.toString,
						r = Math.max,
						o = function (t, e) {
							for (var r = [], o = 0; o < t.length; o += 1) r[o] = t[o];
							for (var n = 0; n < e.length; n += 1) r[n + t.length] = e[n];
							return r;
						};
					t.exports = function (t) {
						var n = this;
						if ("function" != typeof n || "[object Function]" !== e.apply(n))
							throw new TypeError(
								"Function.prototype.bind called on incompatible " + n
							);
						for (
							var i,
								a = (function (t) {
									for (var e = [], r = 1, o = 0; r < t.length; r += 1, o += 1)
										e[o] = t[r];
									return e;
								})(arguments),
								s = r(0, n.length - a.length),
								l = [],
								c = 0;
							c < s;
							c++
						)
							l[c] = "$" + c;
						if (
							((i = Function(
								"binder",
								"return function (" +
									(function (t) {
										for (var e = "", r = 0; r < t.length; r += 1)
											(e += t[r]), r + 1 < t.length && (e += ",");
										return e;
									})(l) +
									"){ return binder.apply(this,arguments); }"
							)(function () {
								if (this instanceof i) {
									var e = n.apply(this, o(a, arguments));
									return Object(e) === e ? e : this;
								}
								return n.apply(t, o(a, arguments));
							})),
							n.prototype)
						) {
							var p = function () {};
							(p.prototype = n.prototype),
								(i.prototype = new p()),
								(p.prototype = null);
						}
						return i;
					};
				},
				989: (t, e, r) => {
					"use strict";
					var o = r(307);
					t.exports = Function.prototype.bind || o;
				},
				375: (t, e, r) => {
					"use strict";
					var o,
						n = r(953),
						i = r(123),
						a = r(780),
						s = r(768),
						l = r(430),
						c = r(277),
						p = r(619),
						u = Function,
						f = function (t) {
							try {
								return u('"use strict"; return (' + t + ").constructor;")();
							} catch (t) {}
						},
						d = Object.getOwnPropertyDescriptor;
					if (d)
						try {
							d({}, "");
						} catch (t) {
							d = null;
						}
					var h = function () {
							throw new c();
						},
						y = d
							? (function () {
									try {
										return h;
									} catch (t) {
										try {
											return d(arguments, "callee").get;
										} catch (t) {
											return h;
										}
									}
								})()
							: h,
						m = r(757)(),
						g = r(442)(),
						b =
							Object.getPrototypeOf ||
							(g
								? function (t) {
										return t.__proto__;
									}
								: null),
						v = {},
						w = "undefined" != typeof Uint8Array && b ? b(Uint8Array) : o,
						S = {
							__proto__: null,
							"%AggregateError%":
								"undefined" == typeof AggregateError ? o : AggregateError,
							"%Array%": Array,
							"%ArrayBuffer%": "undefined" == typeof ArrayBuffer ? o : ArrayBuffer,
							"%ArrayIteratorPrototype%": m && b ? b([][Symbol.iterator]()) : o,
							"%AsyncFromSyncIteratorPrototype%": o,
							"%AsyncFunction%": v,
							"%AsyncGenerator%": v,
							"%AsyncGeneratorFunction%": v,
							"%AsyncIteratorPrototype%": v,
							"%Atomics%": "undefined" == typeof Atomics ? o : Atomics,
							"%BigInt%": "undefined" == typeof BigInt ? o : BigInt,
							"%BigInt64Array%":
								"undefined" == typeof BigInt64Array ? o : BigInt64Array,
							"%BigUint64Array%":
								"undefined" == typeof BigUint64Array ? o : BigUint64Array,
							"%Boolean%": Boolean,
							"%DataView%": "undefined" == typeof DataView ? o : DataView,
							"%Date%": Date,
							"%decodeURI%": decodeURI,
							"%decodeURIComponent%": decodeURIComponent,
							"%encodeURI%": encodeURI,
							"%encodeURIComponent%": encodeURIComponent,
							"%Error%": n,
							"%eval%": eval,
							"%EvalError%": i,
							"%Float32Array%": "undefined" == typeof Float32Array ? o : Float32Array,
							"%Float64Array%": "undefined" == typeof Float64Array ? o : Float64Array,
							"%FinalizationRegistry%":
								"undefined" == typeof FinalizationRegistry
									? o
									: FinalizationRegistry,
							"%Function%": u,
							"%GeneratorFunction%": v,
							"%Int8Array%": "undefined" == typeof Int8Array ? o : Int8Array,
							"%Int16Array%": "undefined" == typeof Int16Array ? o : Int16Array,
							"%Int32Array%": "undefined" == typeof Int32Array ? o : Int32Array,
							"%isFinite%": isFinite,
							"%isNaN%": isNaN,
							"%IteratorPrototype%": m && b ? b(b([][Symbol.iterator]())) : o,
							"%JSON%": "object" == typeof JSON ? JSON : o,
							"%Map%": "undefined" == typeof Map ? o : Map,
							"%MapIteratorPrototype%":
								"undefined" != typeof Map && m && b
									? b(new Map()[Symbol.iterator]())
									: o,
							"%Math%": Math,
							"%Number%": Number,
							"%Object%": Object,
							"%parseFloat%": parseFloat,
							"%parseInt%": parseInt,
							"%Promise%": "undefined" == typeof Promise ? o : Promise,
							"%Proxy%": "undefined" == typeof Proxy ? o : Proxy,
							"%RangeError%": a,
							"%ReferenceError%": s,
							"%Reflect%": "undefined" == typeof Reflect ? o : Reflect,
							"%RegExp%": RegExp,
							"%Set%": "undefined" == typeof Set ? o : Set,
							"%SetIteratorPrototype%":
								"undefined" != typeof Set && m && b
									? b(new Set()[Symbol.iterator]())
									: o,
							"%SharedArrayBuffer%":
								"undefined" == typeof SharedArrayBuffer ? o : SharedArrayBuffer,
							"%String%": String,
							"%StringIteratorPrototype%": m && b ? b(""[Symbol.iterator]()) : o,
							"%Symbol%": m ? Symbol : o,
							"%SyntaxError%": l,
							"%ThrowTypeError%": y,
							"%TypedArray%": w,
							"%TypeError%": c,
							"%Uint8Array%": "undefined" == typeof Uint8Array ? o : Uint8Array,
							"%Uint8ClampedArray%":
								"undefined" == typeof Uint8ClampedArray ? o : Uint8ClampedArray,
							"%Uint16Array%": "undefined" == typeof Uint16Array ? o : Uint16Array,
							"%Uint32Array%": "undefined" == typeof Uint32Array ? o : Uint32Array,
							"%URIError%": p,
							"%WeakMap%": "undefined" == typeof WeakMap ? o : WeakMap,
							"%WeakRef%": "undefined" == typeof WeakRef ? o : WeakRef,
							"%WeakSet%": "undefined" == typeof WeakSet ? o : WeakSet,
						};
					if (b)
						try {
							null.error;
						} catch (t) {
							var E = b(b(t));
							S["%Error.prototype%"] = E;
						}
					var A = function t(e) {
							var r;
							if ("%AsyncFunction%" === e) r = f("async function () {}");
							else if ("%GeneratorFunction%" === e) r = f("function* () {}");
							else if ("%AsyncGeneratorFunction%" === e)
								r = f("async function* () {}");
							else if ("%AsyncGenerator%" === e) {
								var o = t("%AsyncGeneratorFunction%");
								o && (r = o.prototype);
							} else if ("%AsyncIteratorPrototype%" === e) {
								var n = t("%AsyncGenerator%");
								n && b && (r = b(n.prototype));
							}
							return (S[e] = r), r;
						},
						C = {
							__proto__: null,
							"%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
							"%ArrayPrototype%": ["Array", "prototype"],
							"%ArrayProto_entries%": ["Array", "prototype", "entries"],
							"%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
							"%ArrayProto_keys%": ["Array", "prototype", "keys"],
							"%ArrayProto_values%": ["Array", "prototype", "values"],
							"%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
							"%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
							"%AsyncGeneratorPrototype%": [
								"AsyncGeneratorFunction",
								"prototype",
								"prototype",
							],
							"%BooleanPrototype%": ["Boolean", "prototype"],
							"%DataViewPrototype%": ["DataView", "prototype"],
							"%DatePrototype%": ["Date", "prototype"],
							"%ErrorPrototype%": ["Error", "prototype"],
							"%EvalErrorPrototype%": ["EvalError", "prototype"],
							"%Float32ArrayPrototype%": ["Float32Array", "prototype"],
							"%Float64ArrayPrototype%": ["Float64Array", "prototype"],
							"%FunctionPrototype%": ["Function", "prototype"],
							"%Generator%": ["GeneratorFunction", "prototype"],
							"%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
							"%Int8ArrayPrototype%": ["Int8Array", "prototype"],
							"%Int16ArrayPrototype%": ["Int16Array", "prototype"],
							"%Int32ArrayPrototype%": ["Int32Array", "prototype"],
							"%JSONParse%": ["JSON", "parse"],
							"%JSONStringify%": ["JSON", "stringify"],
							"%MapPrototype%": ["Map", "prototype"],
							"%NumberPrototype%": ["Number", "prototype"],
							"%ObjectPrototype%": ["Object", "prototype"],
							"%ObjProto_toString%": ["Object", "prototype", "toString"],
							"%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
							"%PromisePrototype%": ["Promise", "prototype"],
							"%PromiseProto_then%": ["Promise", "prototype", "then"],
							"%Promise_all%": ["Promise", "all"],
							"%Promise_reject%": ["Promise", "reject"],
							"%Promise_resolve%": ["Promise", "resolve"],
							"%RangeErrorPrototype%": ["RangeError", "prototype"],
							"%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
							"%RegExpPrototype%": ["RegExp", "prototype"],
							"%SetPrototype%": ["Set", "prototype"],
							"%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
							"%StringPrototype%": ["String", "prototype"],
							"%SymbolPrototype%": ["Symbol", "prototype"],
							"%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
							"%TypedArrayPrototype%": ["TypedArray", "prototype"],
							"%TypeErrorPrototype%": ["TypeError", "prototype"],
							"%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
							"%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
							"%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
							"%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
							"%URIErrorPrototype%": ["URIError", "prototype"],
							"%WeakMapPrototype%": ["WeakMap", "prototype"],
							"%WeakSetPrototype%": ["WeakSet", "prototype"],
						},
						j = r(989),
						I = r(155),
						O = j.call(Function.call, Array.prototype.concat),
						P = j.call(Function.apply, Array.prototype.splice),
						x = j.call(Function.call, String.prototype.replace),
						B = j.call(Function.call, String.prototype.slice),
						k = j.call(Function.call, RegExp.prototype.exec),
						T =
							/[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g,
						L = /\\(\\)?/g,
						M = function (t, e) {
							var r,
								o = t;
							if ((I(C, o) && (o = "%" + (r = C[o])[0] + "%"), I(S, o))) {
								var n = S[o];
								if ((n === v && (n = A(o)), void 0 === n && !e))
									throw new c(
										"intrinsic " +
											t +
											" exists, but is not available. Please file an issue!"
									);
								return { alias: r, name: o, value: n };
							}
							throw new l("intrinsic " + t + " does not exist!");
						};
					t.exports = function (t, e) {
						if ("string" != typeof t || 0 === t.length)
							throw new c("intrinsic name must be a non-empty string");
						if (arguments.length > 1 && "boolean" != typeof e)
							throw new c('"allowMissing" argument must be a boolean');
						if (null === k(/^%?[^%]*%?$/, t))
							throw new l(
								"`%` may not be present anywhere but at the beginning and end of the intrinsic name"
							);
						var r = (function (t) {
								var e = B(t, 0, 1),
									r = B(t, -1);
								if ("%" === e && "%" !== r)
									throw new l("invalid intrinsic syntax, expected closing `%`");
								if ("%" === r && "%" !== e)
									throw new l("invalid intrinsic syntax, expected opening `%`");
								var o = [];
								return (
									x(t, T, function (t, e, r, n) {
										o[o.length] = r ? x(n, L, "$1") : e || t;
									}),
									o
								);
							})(t),
							o = r.length > 0 ? r[0] : "",
							n = M("%" + o + "%", e),
							i = n.name,
							a = n.value,
							s = !1,
							p = n.alias;
						p && ((o = p[0]), P(r, O([0, 1], p)));
						for (var u = 1, f = !0; u < r.length; u += 1) {
							var h = r[u],
								y = B(h, 0, 1),
								m = B(h, -1);
							if (
								('"' === y ||
									"'" === y ||
									"`" === y ||
									'"' === m ||
									"'" === m ||
									"`" === m) &&
								y !== m
							)
								throw new l("property names with quotes must have matching quotes");
							if (
								(("constructor" !== h && f) || (s = !0),
								I(S, (i = "%" + (o += "." + h) + "%")))
							)
								a = S[i];
							else if (null != a) {
								if (!(h in a)) {
									if (!e)
										throw new c(
											"base intrinsic for " +
												t +
												" exists, but the property is not available."
										);
									return;
								}
								if (d && u + 1 >= r.length) {
									var g = d(a, h);
									a =
										(f = !!g) && "get" in g && !("originalValue" in g.get)
											? g.get
											: a[h];
								} else (f = I(a, h)), (a = a[h]);
								f && !s && (S[i] = a);
							}
						}
						return a;
					};
				},
				553: (t, e, r) => {
					"use strict";
					var o = r(375)("%Object.getOwnPropertyDescriptor%", !0);
					if (o)
						try {
							o([], "length");
						} catch (t) {
							o = null;
						}
					t.exports = o;
				},
				734: (t, e, r) => {
					"use strict";
					var o = r(709),
						n = function () {
							return !!o;
						};
					(n.hasArrayLengthDefineBug = function () {
						if (!o) return null;
						try {
							return 1 !== o([], "length", { value: 1 }).length;
						} catch (t) {
							return !0;
						}
					}),
						(t.exports = n);
				},
				442: (t) => {
					"use strict";
					var e = { __proto__: null, foo: {} },
						r = Object;
					t.exports = function () {
						return { __proto__: e }.foo === e.foo && !(e instanceof r);
					};
				},
				757: (t, e, r) => {
					"use strict";
					var o = "undefined" != typeof Symbol && Symbol,
						n = r(175);
					t.exports = function () {
						return (
							"function" == typeof o &&
							"function" == typeof Symbol &&
							"symbol" == typeof o("foo") &&
							"symbol" == typeof Symbol("bar") &&
							n()
						);
					};
				},
				175: (t) => {
					"use strict";
					t.exports = function () {
						if (
							"function" != typeof Symbol ||
							"function" != typeof Object.getOwnPropertySymbols
						)
							return !1;
						if ("symbol" == typeof Symbol.iterator) return !0;
						var t = {},
							e = Symbol("test"),
							r = Object(e);
						if ("string" == typeof e) return !1;
						if ("[object Symbol]" !== Object.prototype.toString.call(e)) return !1;
						if ("[object Symbol]" !== Object.prototype.toString.call(r)) return !1;
						for (e in ((t[e] = 42), t)) return !1;
						if ("function" == typeof Object.keys && 0 !== Object.keys(t).length)
							return !1;
						if (
							"function" == typeof Object.getOwnPropertyNames &&
							0 !== Object.getOwnPropertyNames(t).length
						)
							return !1;
						var o = Object.getOwnPropertySymbols(t);
						if (1 !== o.length || o[0] !== e) return !1;
						if (!Object.prototype.propertyIsEnumerable.call(t, e)) return !1;
						if ("function" == typeof Object.getOwnPropertyDescriptor) {
							var n = Object.getOwnPropertyDescriptor(t, e);
							if (42 !== n.value || !0 !== n.enumerable) return !1;
						}
						return !0;
					};
				},
				155: (t, e, r) => {
					"use strict";
					var o = Function.prototype.call,
						n = Object.prototype.hasOwnProperty,
						i = r(989);
					t.exports = i.call(o, n);
				},
				141: (t, e, r) => {
					var o = "function" == typeof Map && Map.prototype,
						n =
							Object.getOwnPropertyDescriptor && o
								? Object.getOwnPropertyDescriptor(Map.prototype, "size")
								: null,
						i = o && n && "function" == typeof n.get ? n.get : null,
						a = o && Map.prototype.forEach,
						s = "function" == typeof Set && Set.prototype,
						l =
							Object.getOwnPropertyDescriptor && s
								? Object.getOwnPropertyDescriptor(Set.prototype, "size")
								: null,
						c = s && l && "function" == typeof l.get ? l.get : null,
						p = s && Set.prototype.forEach,
						u =
							"function" == typeof WeakMap && WeakMap.prototype
								? WeakMap.prototype.has
								: null,
						f =
							"function" == typeof WeakSet && WeakSet.prototype
								? WeakSet.prototype.has
								: null,
						d =
							"function" == typeof WeakRef && WeakRef.prototype
								? WeakRef.prototype.deref
								: null,
						h = Boolean.prototype.valueOf,
						y = Object.prototype.toString,
						m = Function.prototype.toString,
						g = String.prototype.match,
						b = String.prototype.slice,
						v = String.prototype.replace,
						w = String.prototype.toUpperCase,
						S = String.prototype.toLowerCase,
						E = RegExp.prototype.test,
						A = Array.prototype.concat,
						C = Array.prototype.join,
						j = Array.prototype.slice,
						I = Math.floor,
						O = "function" == typeof BigInt ? BigInt.prototype.valueOf : null,
						P = Object.getOwnPropertySymbols,
						x =
							"function" == typeof Symbol && "symbol" == typeof Symbol.iterator
								? Symbol.prototype.toString
								: null,
						B = "function" == typeof Symbol && "object" == typeof Symbol.iterator,
						k =
							"function" == typeof Symbol &&
							Symbol.toStringTag &&
							(Symbol.toStringTag, 1)
								? Symbol.toStringTag
								: null,
						T = Object.prototype.propertyIsEnumerable,
						L =
							("function" == typeof Reflect
								? Reflect.getPrototypeOf
								: Object.getPrototypeOf) ||
							([].__proto__ === Array.prototype
								? function (t) {
										return t.__proto__;
									}
								: null);
					function M(t, e) {
						if (
							t === 1 / 0 ||
							t === -1 / 0 ||
							t != t ||
							(t && t > -1e3 && t < 1e3) ||
							E.call(/e/, e)
						)
							return e;
						var r = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
						if ("number" == typeof t) {
							var o = t < 0 ? -I(-t) : I(t);
							if (o !== t) {
								var n = String(o),
									i = b.call(e, n.length + 1);
								return (
									v.call(n, r, "$&_") +
									"." +
									v.call(v.call(i, /([0-9]{3})/g, "$&_"), /_$/, "")
								);
							}
						}
						return v.call(e, r, "$&_");
					}
					var R = r(634),
						N = R.custom,
						D = H(N) ? N : null;
					function F(t, e, r) {
						var o = "double" === (r.quoteStyle || e) ? '"' : "'";
						return o + t + o;
					}
					function _(t) {
						return v.call(String(t), /"/g, "&quot;");
					}
					function $(t) {
						return !(
							"[object Array]" !== q(t) ||
							(k && "object" == typeof t && k in t)
						);
					}
					function W(t) {
						return !(
							"[object RegExp]" !== q(t) ||
							(k && "object" == typeof t && k in t)
						);
					}
					function H(t) {
						if (B) return t && "object" == typeof t && t instanceof Symbol;
						if ("symbol" == typeof t) return !0;
						if (!t || "object" != typeof t || !x) return !1;
						try {
							return x.call(t), !0;
						} catch (t) {}
						return !1;
					}
					t.exports = function t(e, o, n, s) {
						var l = o || {};
						if (
							V(l, "quoteStyle") &&
							"single" !== l.quoteStyle &&
							"double" !== l.quoteStyle
						)
							throw new TypeError('option "quoteStyle" must be "single" or "double"');
						if (
							V(l, "maxStringLength") &&
							("number" == typeof l.maxStringLength
								? l.maxStringLength < 0 && l.maxStringLength !== 1 / 0
								: null !== l.maxStringLength)
						)
							throw new TypeError(
								'option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`'
							);
						var y = !V(l, "customInspect") || l.customInspect;
						if ("boolean" != typeof y && "symbol" !== y)
							throw new TypeError(
								"option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`"
							);
						if (
							V(l, "indent") &&
							null !== l.indent &&
							"\t" !== l.indent &&
							!(parseInt(l.indent, 10) === l.indent && l.indent > 0)
						)
							throw new TypeError(
								'option "indent" must be "\\t", an integer > 0, or `null`'
							);
						if (V(l, "numericSeparator") && "boolean" != typeof l.numericSeparator)
							throw new TypeError(
								'option "numericSeparator", if provided, must be `true` or `false`'
							);
						var w = l.numericSeparator;
						if (void 0 === e) return "undefined";
						if (null === e) return "null";
						if ("boolean" == typeof e) return e ? "true" : "false";
						if ("string" == typeof e) return G(e, l);
						if ("number" == typeof e) {
							if (0 === e) return 1 / 0 / e > 0 ? "0" : "-0";
							var E = String(e);
							return w ? M(e, E) : E;
						}
						if ("bigint" == typeof e) {
							var I = String(e) + "n";
							return w ? M(e, I) : I;
						}
						var P = void 0 === l.depth ? 5 : l.depth;
						if ((void 0 === n && (n = 0), n >= P && P > 0 && "object" == typeof e))
							return $(e) ? "[Array]" : "[Object]";
						var N = (function (t, e) {
							var r;
							if ("\t" === t.indent) r = "\t";
							else {
								if (!("number" == typeof t.indent && t.indent > 0)) return null;
								r = C.call(Array(t.indent + 1), " ");
							}
							return { base: r, prev: C.call(Array(e + 1), r) };
						})(l, n);
						if (void 0 === s) s = [];
						else if (z(s, e) >= 0) return "[Circular]";
						function U(e, r, o) {
							if ((r && (s = j.call(s)).push(r), o)) {
								var i = { depth: l.depth };
								return (
									V(l, "quoteStyle") && (i.quoteStyle = l.quoteStyle),
									t(e, i, n + 1, s)
								);
							}
							return t(e, l, n + 1, s);
						}
						if ("function" == typeof e && !W(e)) {
							var K = (function (t) {
									if (t.name) return t.name;
									var e = g.call(m.call(t), /^function\s*([\w$]+)/);
									return e ? e[1] : null;
								})(e),
								tt = Y(e, U);
							return (
								"[Function" +
								(K ? ": " + K : " (anonymous)") +
								"]" +
								(tt.length > 0 ? " { " + C.call(tt, ", ") + " }" : "")
							);
						}
						if (H(e)) {
							var et = B
								? v.call(String(e), /^(Symbol\(.*\))_[^)]*$/, "$1")
								: x.call(e);
							return "object" != typeof e || B ? et : Q(et);
						}
						if (
							(function (t) {
								return (
									!(!t || "object" != typeof t) &&
									(("undefined" != typeof HTMLElement &&
										t instanceof HTMLElement) ||
										("string" == typeof t.nodeName &&
											"function" == typeof t.getAttribute))
								);
							})(e)
						) {
							for (
								var rt = "<" + S.call(String(e.nodeName)),
									ot = e.attributes || [],
									nt = 0;
								nt < ot.length;
								nt++
							)
								rt += " " + ot[nt].name + "=" + F(_(ot[nt].value), "double", l);
							return (
								(rt += ">"),
								e.childNodes && e.childNodes.length && (rt += "..."),
								rt + "</" + S.call(String(e.nodeName)) + ">"
							);
						}
						if ($(e)) {
							if (0 === e.length) return "[]";
							var it = Y(e, U);
							return N &&
								!(function (t) {
									for (var e = 0; e < t.length; e++)
										if (z(t[e], "\n") >= 0) return !1;
									return !0;
								})(it)
								? "[" + X(it, N) + "]"
								: "[ " + C.call(it, ", ") + " ]";
						}
						if (
							(function (t) {
								return !(
									"[object Error]" !== q(t) ||
									(k && "object" == typeof t && k in t)
								);
							})(e)
						) {
							var at = Y(e, U);
							return "cause" in Error.prototype ||
								!("cause" in e) ||
								T.call(e, "cause")
								? 0 === at.length
									? "[" + String(e) + "]"
									: "{ [" + String(e) + "] " + C.call(at, ", ") + " }"
								: "{ [" +
										String(e) +
										"] " +
										C.call(A.call("[cause]: " + U(e.cause), at), ", ") +
										" }";
						}
						if ("object" == typeof e && y) {
							if (D && "function" == typeof e[D] && R) return R(e, { depth: P - n });
							if ("symbol" !== y && "function" == typeof e.inspect)
								return e.inspect();
						}
						if (
							(function (t) {
								if (!i || !t || "object" != typeof t) return !1;
								try {
									i.call(t);
									try {
										c.call(t);
									} catch (t) {
										return !0;
									}
									return t instanceof Map;
								} catch (t) {}
								return !1;
							})(e)
						) {
							var st = [];
							return (
								a &&
									a.call(e, function (t, r) {
										st.push(U(r, e, !0) + " => " + U(t, e));
									}),
								Z("Map", i.call(e), st, N)
							);
						}
						if (
							(function (t) {
								if (!c || !t || "object" != typeof t) return !1;
								try {
									c.call(t);
									try {
										i.call(t);
									} catch (t) {
										return !0;
									}
									return t instanceof Set;
								} catch (t) {}
								return !1;
							})(e)
						) {
							var lt = [];
							return (
								p &&
									p.call(e, function (t) {
										lt.push(U(t, e));
									}),
								Z("Set", c.call(e), lt, N)
							);
						}
						if (
							(function (t) {
								if (!u || !t || "object" != typeof t) return !1;
								try {
									u.call(t, u);
									try {
										f.call(t, f);
									} catch (t) {
										return !0;
									}
									return t instanceof WeakMap;
								} catch (t) {}
								return !1;
							})(e)
						)
							return J("WeakMap");
						if (
							(function (t) {
								if (!f || !t || "object" != typeof t) return !1;
								try {
									f.call(t, f);
									try {
										u.call(t, u);
									} catch (t) {
										return !0;
									}
									return t instanceof WeakSet;
								} catch (t) {}
								return !1;
							})(e)
						)
							return J("WeakSet");
						if (
							(function (t) {
								if (!d || !t || "object" != typeof t) return !1;
								try {
									return d.call(t), !0;
								} catch (t) {}
								return !1;
							})(e)
						)
							return J("WeakRef");
						if (
							(function (t) {
								return !(
									"[object Number]" !== q(t) ||
									(k && "object" == typeof t && k in t)
								);
							})(e)
						)
							return Q(U(Number(e)));
						if (
							(function (t) {
								if (!t || "object" != typeof t || !O) return !1;
								try {
									return O.call(t), !0;
								} catch (t) {}
								return !1;
							})(e)
						)
							return Q(U(O.call(e)));
						if (
							(function (t) {
								return !(
									"[object Boolean]" !== q(t) ||
									(k && "object" == typeof t && k in t)
								);
							})(e)
						)
							return Q(h.call(e));
						if (
							(function (t) {
								return !(
									"[object String]" !== q(t) ||
									(k && "object" == typeof t && k in t)
								);
							})(e)
						)
							return Q(U(String(e)));
						if ("undefined" != typeof window && e === window)
							return "{ [object Window] }";
						if (
							("undefined" != typeof globalThis && e === globalThis) ||
							(void 0 !== r.g && e === r.g)
						)
							return "{ [object globalThis] }";
						if (
							!(function (t) {
								return !(
									"[object Date]" !== q(t) ||
									(k && "object" == typeof t && k in t)
								);
							})(e) &&
							!W(e)
						) {
							var ct = Y(e, U),
								pt = L
									? L(e) === Object.prototype
									: e instanceof Object || e.constructor === Object,
								ut = e instanceof Object ? "" : "null prototype",
								ft =
									!pt && k && Object(e) === e && k in e
										? b.call(q(e), 8, -1)
										: ut
											? "Object"
											: "",
								dt =
									(pt || "function" != typeof e.constructor
										? ""
										: e.constructor.name
											? e.constructor.name + " "
											: "") +
									(ft || ut
										? "[" + C.call(A.call([], ft || [], ut || []), ": ") + "] "
										: "");
							return 0 === ct.length
								? dt + "{}"
								: N
									? dt + "{" + X(ct, N) + "}"
									: dt + "{ " + C.call(ct, ", ") + " }";
						}
						return String(e);
					};
					var U =
						Object.prototype.hasOwnProperty ||
						function (t) {
							return t in this;
						};
					function V(t, e) {
						return U.call(t, e);
					}
					function q(t) {
						return y.call(t);
					}
					function z(t, e) {
						if (t.indexOf) return t.indexOf(e);
						for (var r = 0, o = t.length; r < o; r++) if (t[r] === e) return r;
						return -1;
					}
					function G(t, e) {
						if (t.length > e.maxStringLength) {
							var r = t.length - e.maxStringLength,
								o = "... " + r + " more character" + (r > 1 ? "s" : "");
							return G(b.call(t, 0, e.maxStringLength), e) + o;
						}
						return F(
							v.call(v.call(t, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, K),
							"single",
							e
						);
					}
					function K(t) {
						var e = t.charCodeAt(0),
							r = { 8: "b", 9: "t", 10: "n", 12: "f", 13: "r" }[e];
						return r ? "\\" + r : "\\x" + (e < 16 ? "0" : "") + w.call(e.toString(16));
					}
					function Q(t) {
						return "Object(" + t + ")";
					}
					function J(t) {
						return t + " { ? }";
					}
					function Z(t, e, r, o) {
						return t + " (" + e + ") {" + (o ? X(r, o) : C.call(r, ", ")) + "}";
					}
					function X(t, e) {
						if (0 === t.length) return "";
						var r = "\n" + e.prev + e.base;
						return r + C.call(t, "," + r) + "\n" + e.prev;
					}
					function Y(t, e) {
						var r = $(t),
							o = [];
						if (r) {
							o.length = t.length;
							for (var n = 0; n < t.length; n++) o[n] = V(t, n) ? e(t[n], t) : "";
						}
						var i,
							a = "function" == typeof P ? P(t) : [];
						if (B) {
							i = {};
							for (var s = 0; s < a.length; s++) i["$" + a[s]] = a[s];
						}
						for (var l in t)
							V(t, l) &&
								((r && String(Number(l)) === l && l < t.length) ||
									(B && i["$" + l] instanceof Symbol) ||
									(E.call(/[^\w$]/, l)
										? o.push(e(l, t) + ": " + e(t[l], t))
										: o.push(l + ": " + e(t[l], t))));
						if ("function" == typeof P)
							for (var c = 0; c < a.length; c++)
								T.call(t, a[c]) && o.push("[" + e(a[c]) + "]: " + e(t[a[c]], t));
						return o;
					}
				},
				640: (t) => {
					"use strict";
					var e = String.prototype.replace,
						r = /%20/g,
						o = "RFC3986";
					t.exports = {
						default: o,
						formatters: {
							RFC1738: function (t) {
								return e.call(t, r, "+");
							},
							RFC3986: function (t) {
								return String(t);
							},
						},
						RFC1738: "RFC1738",
						RFC3986: o,
					};
				},
				215: (t, e, r) => {
					"use strict";
					var o = r(518),
						n = r(968),
						i = r(640);
					t.exports = { formats: i, parse: n, stringify: o };
				},
				968: (t, e, r) => {
					"use strict";
					var o = r(570),
						n = Object.prototype.hasOwnProperty,
						i = Array.isArray,
						a = {
							allowDots: !1,
							allowEmptyArrays: !1,
							allowPrototypes: !1,
							allowSparse: !1,
							arrayLimit: 20,
							charset: "utf-8",
							charsetSentinel: !1,
							comma: !1,
							decodeDotInKeys: !1,
							decoder: o.decode,
							delimiter: "&",
							depth: 5,
							duplicates: "combine",
							ignoreQueryPrefix: !1,
							interpretNumericEntities: !1,
							parameterLimit: 1e3,
							parseArrays: !0,
							plainObjects: !1,
							strictDepth: !1,
							strictNullHandling: !1,
						},
						s = function (t) {
							return t.replace(/&#(\d+);/g, function (t, e) {
								return String.fromCharCode(parseInt(e, 10));
							});
						},
						l = function (t, e) {
							return t && "string" == typeof t && e.comma && t.indexOf(",") > -1
								? t.split(",")
								: t;
						},
						c = function (t, e, r, o) {
							if (t) {
								var i = r.allowDots ? t.replace(/\.([^.[]+)/g, "[$1]") : t,
									a = /(\[[^[\]]*])/g,
									s = r.depth > 0 && /(\[[^[\]]*])/.exec(i),
									c = s ? i.slice(0, s.index) : i,
									p = [];
								if (c) {
									if (
										!r.plainObjects &&
										n.call(Object.prototype, c) &&
										!r.allowPrototypes
									)
										return;
									p.push(c);
								}
								for (
									var u = 0;
									r.depth > 0 && null !== (s = a.exec(i)) && u < r.depth;

								) {
									if (
										((u += 1),
										!r.plainObjects &&
											n.call(Object.prototype, s[1].slice(1, -1)) &&
											!r.allowPrototypes)
									)
										return;
									p.push(s[1]);
								}
								if (s) {
									if (!0 === r.strictDepth)
										throw new RangeError(
											"Input depth exceeded depth option of " +
												r.depth +
												" and strictDepth is true"
										);
									p.push("[" + i.slice(s.index) + "]");
								}
								return (function (t, e, r, o) {
									for (var n = o ? e : l(e, r), i = t.length - 1; i >= 0; --i) {
										var a,
											s = t[i];
										if ("[]" === s && r.parseArrays)
											a =
												r.allowEmptyArrays &&
												("" === n || (r.strictNullHandling && null === n))
													? []
													: [].concat(n);
										else {
											a = r.plainObjects ? Object.create(null) : {};
											var c =
													"[" === s.charAt(0) &&
													"]" === s.charAt(s.length - 1)
														? s.slice(1, -1)
														: s,
												p = r.decodeDotInKeys ? c.replace(/%2E/g, ".") : c,
												u = parseInt(p, 10);
											r.parseArrays || "" !== p
												? !isNaN(u) &&
													s !== p &&
													String(u) === p &&
													u >= 0 &&
													r.parseArrays &&
													u <= r.arrayLimit
													? ((a = [])[u] = n)
													: "__proto__" !== p && (a[p] = n)
												: (a = { 0: n });
										}
										n = a;
									}
									return n;
								})(p, e, r, o);
							}
						};
					t.exports = function (t, e) {
						var r = (function (t) {
							if (!t) return a;
							if (
								void 0 !== t.allowEmptyArrays &&
								"boolean" != typeof t.allowEmptyArrays
							)
								throw new TypeError(
									"`allowEmptyArrays` option can only be `true` or `false`, when provided"
								);
							if (
								void 0 !== t.decodeDotInKeys &&
								"boolean" != typeof t.decodeDotInKeys
							)
								throw new TypeError(
									"`decodeDotInKeys` option can only be `true` or `false`, when provided"
								);
							if (
								null !== t.decoder &&
								void 0 !== t.decoder &&
								"function" != typeof t.decoder
							)
								throw new TypeError("Decoder has to be a function.");
							if (
								void 0 !== t.charset &&
								"utf-8" !== t.charset &&
								"iso-8859-1" !== t.charset
							)
								throw new TypeError(
									"The charset option must be either utf-8, iso-8859-1, or undefined"
								);
							var e = void 0 === t.charset ? a.charset : t.charset,
								r = void 0 === t.duplicates ? a.duplicates : t.duplicates;
							if ("combine" !== r && "first" !== r && "last" !== r)
								throw new TypeError(
									"The duplicates option must be either combine, first, or last"
								);
							return {
								allowDots:
									void 0 === t.allowDots
										? !0 === t.decodeDotInKeys || a.allowDots
										: !!t.allowDots,
								allowEmptyArrays:
									"boolean" == typeof t.allowEmptyArrays
										? !!t.allowEmptyArrays
										: a.allowEmptyArrays,
								allowPrototypes:
									"boolean" == typeof t.allowPrototypes
										? t.allowPrototypes
										: a.allowPrototypes,
								allowSparse:
									"boolean" == typeof t.allowSparse
										? t.allowSparse
										: a.allowSparse,
								arrayLimit:
									"number" == typeof t.arrayLimit ? t.arrayLimit : a.arrayLimit,
								charset: e,
								charsetSentinel:
									"boolean" == typeof t.charsetSentinel
										? t.charsetSentinel
										: a.charsetSentinel,
								comma: "boolean" == typeof t.comma ? t.comma : a.comma,
								decodeDotInKeys:
									"boolean" == typeof t.decodeDotInKeys
										? t.decodeDotInKeys
										: a.decodeDotInKeys,
								decoder: "function" == typeof t.decoder ? t.decoder : a.decoder,
								delimiter:
									"string" == typeof t.delimiter || o.isRegExp(t.delimiter)
										? t.delimiter
										: a.delimiter,
								depth:
									"number" == typeof t.depth || !1 === t.depth
										? +t.depth
										: a.depth,
								duplicates: r,
								ignoreQueryPrefix: !0 === t.ignoreQueryPrefix,
								interpretNumericEntities:
									"boolean" == typeof t.interpretNumericEntities
										? t.interpretNumericEntities
										: a.interpretNumericEntities,
								parameterLimit:
									"number" == typeof t.parameterLimit
										? t.parameterLimit
										: a.parameterLimit,
								parseArrays: !1 !== t.parseArrays,
								plainObjects:
									"boolean" == typeof t.plainObjects
										? t.plainObjects
										: a.plainObjects,
								strictDepth:
									"boolean" == typeof t.strictDepth
										? !!t.strictDepth
										: a.strictDepth,
								strictNullHandling:
									"boolean" == typeof t.strictNullHandling
										? t.strictNullHandling
										: a.strictNullHandling,
							};
						})(e);
						if ("" === t || null == t) return r.plainObjects ? Object.create(null) : {};
						for (
							var p =
									"string" == typeof t
										? (function (t, e) {
												var r = { __proto__: null },
													c = e.ignoreQueryPrefix
														? t.replace(/^\?/, "")
														: t;
												c = c.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
												var p,
													u =
														e.parameterLimit === 1 / 0
															? void 0
															: e.parameterLimit,
													f = c.split(e.delimiter, u),
													d = -1,
													h = e.charset;
												if (e.charsetSentinel)
													for (p = 0; p < f.length; ++p)
														0 === f[p].indexOf("utf8=") &&
															("utf8=%E2%9C%93" === f[p]
																? (h = "utf-8")
																: "utf8=%26%2310003%3B" === f[p] &&
																	(h = "iso-8859-1"),
															(d = p),
															(p = f.length));
												for (p = 0; p < f.length; ++p)
													if (p !== d) {
														var y,
															m,
															g = f[p],
															b = g.indexOf("]="),
															v = -1 === b ? g.indexOf("=") : b + 1;
														-1 === v
															? ((y = e.decoder(
																	g,
																	a.decoder,
																	h,
																	"key"
																)),
																(m = e.strictNullHandling
																	? null
																	: ""))
															: ((y = e.decoder(
																	g.slice(0, v),
																	a.decoder,
																	h,
																	"key"
																)),
																(m = o.maybeMap(
																	l(g.slice(v + 1), e),
																	function (t) {
																		return e.decoder(
																			t,
																			a.decoder,
																			h,
																			"value"
																		);
																	}
																))),
															m &&
																e.interpretNumericEntities &&
																"iso-8859-1" === h &&
																(m = s(m)),
															g.indexOf("[]=") > -1 &&
																(m = i(m) ? [m] : m);
														var w = n.call(r, y);
														w && "combine" === e.duplicates
															? (r[y] = o.combine(r[y], m))
															: (w && "last" !== e.duplicates) ||
																(r[y] = m);
													}
												return r;
											})(t, r)
										: t,
								u = r.plainObjects ? Object.create(null) : {},
								f = Object.keys(p),
								d = 0;
							d < f.length;
							++d
						) {
							var h = f[d],
								y = c(h, p[h], r, "string" == typeof t);
							u = o.merge(u, y, r);
						}
						return !0 === r.allowSparse ? u : o.compact(u);
					};
				},
				518: (t, e, r) => {
					"use strict";
					var o = r(670),
						n = r(570),
						i = r(640),
						a = Object.prototype.hasOwnProperty,
						s = {
							brackets: function (t) {
								return t + "[]";
							},
							comma: "comma",
							indices: function (t, e) {
								return t + "[" + e + "]";
							},
							repeat: function (t) {
								return t;
							},
						},
						l = Array.isArray,
						c = Array.prototype.push,
						p = function (t, e) {
							c.apply(t, l(e) ? e : [e]);
						},
						u = Date.prototype.toISOString,
						f = i.default,
						d = {
							addQueryPrefix: !1,
							allowDots: !1,
							allowEmptyArrays: !1,
							arrayFormat: "indices",
							charset: "utf-8",
							charsetSentinel: !1,
							delimiter: "&",
							encode: !0,
							encodeDotInKeys: !1,
							encoder: n.encode,
							encodeValuesOnly: !1,
							format: f,
							formatter: i.formatters[f],
							indices: !1,
							serializeDate: function (t) {
								return u.call(t);
							},
							skipNulls: !1,
							strictNullHandling: !1,
						},
						h = {},
						y = function t(e, r, i, a, s, c, u, f, y, m, g, b, v, w, S, E, A, C) {
							for (
								var j, I = e, O = C, P = 0, x = !1;
								void 0 !== (O = O.get(h)) && !x;

							) {
								var B = O.get(e);
								if (((P += 1), void 0 !== B)) {
									if (B === P) throw new RangeError("Cyclic object value");
									x = !0;
								}
								void 0 === O.get(h) && (P = 0);
							}
							if (
								("function" == typeof m
									? (I = m(r, I))
									: I instanceof Date
										? (I = v(I))
										: "comma" === i &&
											l(I) &&
											(I = n.maybeMap(I, function (t) {
												return t instanceof Date ? v(t) : t;
											})),
								null === I)
							) {
								if (c) return y && !E ? y(r, d.encoder, A, "key", w) : r;
								I = "";
							}
							if (
								"string" == typeof (j = I) ||
								"number" == typeof j ||
								"boolean" == typeof j ||
								"symbol" == typeof j ||
								"bigint" == typeof j ||
								n.isBuffer(I)
							)
								return y
									? [
											S(E ? r : y(r, d.encoder, A, "key", w)) +
												"=" +
												S(y(I, d.encoder, A, "value", w)),
										]
									: [S(r) + "=" + S(String(I))];
							var k,
								T = [];
							if (void 0 === I) return T;
							if ("comma" === i && l(I))
								E && y && (I = n.maybeMap(I, y)),
									(k = [{ value: I.length > 0 ? I.join(",") || null : void 0 }]);
							else if (l(m)) k = m;
							else {
								var L = Object.keys(I);
								k = g ? L.sort(g) : L;
							}
							var M = f ? r.replace(/\./g, "%2E") : r,
								R = a && l(I) && 1 === I.length ? M + "[]" : M;
							if (s && l(I) && 0 === I.length) return R + "[]";
							for (var N = 0; N < k.length; ++N) {
								var D = k[N],
									F = "object" == typeof D && void 0 !== D.value ? D.value : I[D];
								if (!u || null !== F) {
									var _ = b && f ? D.replace(/\./g, "%2E") : D,
										$ = l(I)
											? "function" == typeof i
												? i(R, _)
												: R
											: R + (b ? "." + _ : "[" + _ + "]");
									C.set(e, P);
									var W = o();
									W.set(h, C),
										p(
											T,
											t(
												F,
												$,
												i,
												a,
												s,
												c,
												u,
												f,
												"comma" === i && E && l(I) ? null : y,
												m,
												g,
												b,
												v,
												w,
												S,
												E,
												A,
												W
											)
										);
								}
							}
							return T;
						};
					t.exports = function (t, e) {
						var r,
							n = t,
							c = (function (t) {
								if (!t) return d;
								if (
									void 0 !== t.allowEmptyArrays &&
									"boolean" != typeof t.allowEmptyArrays
								)
									throw new TypeError(
										"`allowEmptyArrays` option can only be `true` or `false`, when provided"
									);
								if (
									void 0 !== t.encodeDotInKeys &&
									"boolean" != typeof t.encodeDotInKeys
								)
									throw new TypeError(
										"`encodeDotInKeys` option can only be `true` or `false`, when provided"
									);
								if (
									null !== t.encoder &&
									void 0 !== t.encoder &&
									"function" != typeof t.encoder
								)
									throw new TypeError("Encoder has to be a function.");
								var e = t.charset || d.charset;
								if (
									void 0 !== t.charset &&
									"utf-8" !== t.charset &&
									"iso-8859-1" !== t.charset
								)
									throw new TypeError(
										"The charset option must be either utf-8, iso-8859-1, or undefined"
									);
								var r = i.default;
								if (void 0 !== t.format) {
									if (!a.call(i.formatters, t.format))
										throw new TypeError("Unknown format option provided.");
									r = t.format;
								}
								var o,
									n = i.formatters[r],
									c = d.filter;
								if (
									(("function" == typeof t.filter || l(t.filter)) &&
										(c = t.filter),
									(o =
										t.arrayFormat in s
											? t.arrayFormat
											: "indices" in t
												? t.indices
													? "indices"
													: "repeat"
												: d.arrayFormat),
									"commaRoundTrip" in t && "boolean" != typeof t.commaRoundTrip)
								)
									throw new TypeError(
										"`commaRoundTrip` must be a boolean, or absent"
									);
								var p =
									void 0 === t.allowDots
										? !0 === t.encodeDotInKeys || d.allowDots
										: !!t.allowDots;
								return {
									addQueryPrefix:
										"boolean" == typeof t.addQueryPrefix
											? t.addQueryPrefix
											: d.addQueryPrefix,
									allowDots: p,
									allowEmptyArrays:
										"boolean" == typeof t.allowEmptyArrays
											? !!t.allowEmptyArrays
											: d.allowEmptyArrays,
									arrayFormat: o,
									charset: e,
									charsetSentinel:
										"boolean" == typeof t.charsetSentinel
											? t.charsetSentinel
											: d.charsetSentinel,
									commaRoundTrip: t.commaRoundTrip,
									delimiter: void 0 === t.delimiter ? d.delimiter : t.delimiter,
									encode: "boolean" == typeof t.encode ? t.encode : d.encode,
									encodeDotInKeys:
										"boolean" == typeof t.encodeDotInKeys
											? t.encodeDotInKeys
											: d.encodeDotInKeys,
									encoder: "function" == typeof t.encoder ? t.encoder : d.encoder,
									encodeValuesOnly:
										"boolean" == typeof t.encodeValuesOnly
											? t.encodeValuesOnly
											: d.encodeValuesOnly,
									filter: c,
									format: r,
									formatter: n,
									serializeDate:
										"function" == typeof t.serializeDate
											? t.serializeDate
											: d.serializeDate,
									skipNulls:
										"boolean" == typeof t.skipNulls ? t.skipNulls : d.skipNulls,
									sort: "function" == typeof t.sort ? t.sort : null,
									strictNullHandling:
										"boolean" == typeof t.strictNullHandling
											? t.strictNullHandling
											: d.strictNullHandling,
								};
							})(e);
						"function" == typeof c.filter
							? (n = (0, c.filter)("", n))
							: l(c.filter) && (r = c.filter);
						var u = [];
						if ("object" != typeof n || null === n) return "";
						var f = s[c.arrayFormat],
							h = "comma" === f && c.commaRoundTrip;
						r || (r = Object.keys(n)), c.sort && r.sort(c.sort);
						for (var m = o(), g = 0; g < r.length; ++g) {
							var b = r[g];
							(c.skipNulls && null === n[b]) ||
								p(
									u,
									y(
										n[b],
										b,
										f,
										h,
										c.allowEmptyArrays,
										c.strictNullHandling,
										c.skipNulls,
										c.encodeDotInKeys,
										c.encode ? c.encoder : null,
										c.filter,
										c.sort,
										c.allowDots,
										c.serializeDate,
										c.format,
										c.formatter,
										c.encodeValuesOnly,
										c.charset,
										m
									)
								);
						}
						var v = u.join(c.delimiter),
							w = !0 === c.addQueryPrefix ? "?" : "";
						return (
							c.charsetSentinel &&
								("iso-8859-1" === c.charset
									? (w += "utf8=%26%2310003%3B&")
									: (w += "utf8=%E2%9C%93&")),
							v.length > 0 ? w + v : ""
						);
					};
				},
				570: (t, e, r) => {
					"use strict";
					var o = r(640),
						n = Object.prototype.hasOwnProperty,
						i = Array.isArray,
						a = (function () {
							for (var t = [], e = 0; e < 256; ++e)
								t.push("%" + ((e < 16 ? "0" : "") + e.toString(16)).toUpperCase());
							return t;
						})(),
						s = function (t, e) {
							for (
								var r = e && e.plainObjects ? Object.create(null) : {}, o = 0;
								o < t.length;
								++o
							)
								void 0 !== t[o] && (r[o] = t[o]);
							return r;
						},
						l = 1024;
					t.exports = {
						arrayToObject: s,
						assign: function (t, e) {
							return Object.keys(e).reduce(function (t, r) {
								return (t[r] = e[r]), t;
							}, t);
						},
						combine: function (t, e) {
							return [].concat(t, e);
						},
						compact: function (t) {
							for (
								var e = [{ obj: { o: t }, prop: "o" }], r = [], o = 0;
								o < e.length;
								++o
							)
								for (
									var n = e[o], a = n.obj[n.prop], s = Object.keys(a), l = 0;
									l < s.length;
									++l
								) {
									var c = s[l],
										p = a[c];
									"object" == typeof p &&
										null !== p &&
										-1 === r.indexOf(p) &&
										(e.push({ obj: a, prop: c }), r.push(p));
								}
							return (
								(function (t) {
									for (; t.length > 1; ) {
										var e = t.pop(),
											r = e.obj[e.prop];
										if (i(r)) {
											for (var o = [], n = 0; n < r.length; ++n)
												void 0 !== r[n] && o.push(r[n]);
											e.obj[e.prop] = o;
										}
									}
								})(e),
								t
							);
						},
						decode: function (t, e, r) {
							var o = t.replace(/\+/g, " ");
							if ("iso-8859-1" === r) return o.replace(/%[0-9a-f]{2}/gi, unescape);
							try {
								return decodeURIComponent(o);
							} catch (t) {
								return o;
							}
						},
						encode: function (t, e, r, n, i) {
							if (0 === t.length) return t;
							var s = t;
							if (
								("symbol" == typeof t
									? (s = Symbol.prototype.toString.call(t))
									: "string" != typeof t && (s = String(t)),
								"iso-8859-1" === r)
							)
								return escape(s).replace(/%u[0-9a-f]{4}/gi, function (t) {
									return "%26%23" + parseInt(t.slice(2), 16) + "%3B";
								});
							for (var c = "", p = 0; p < s.length; p += l) {
								for (
									var u = s.length >= l ? s.slice(p, p + l) : s, f = [], d = 0;
									d < u.length;
									++d
								) {
									var h = u.charCodeAt(d);
									45 === h ||
									46 === h ||
									95 === h ||
									126 === h ||
									(h >= 48 && h <= 57) ||
									(h >= 65 && h <= 90) ||
									(h >= 97 && h <= 122) ||
									(i === o.RFC1738 && (40 === h || 41 === h))
										? (f[f.length] = u.charAt(d))
										: h < 128
											? (f[f.length] = a[h])
											: h < 2048
												? (f[f.length] =
														a[192 | (h >> 6)] + a[128 | (63 & h)])
												: h < 55296 || h >= 57344
													? (f[f.length] =
															a[224 | (h >> 12)] +
															a[128 | ((h >> 6) & 63)] +
															a[128 | (63 & h)])
													: ((d += 1),
														(h =
															65536 +
															(((1023 & h) << 10) |
																(1023 & u.charCodeAt(d)))),
														(f[f.length] =
															a[240 | (h >> 18)] +
															a[128 | ((h >> 12) & 63)] +
															a[128 | ((h >> 6) & 63)] +
															a[128 | (63 & h)]));
								}
								c += f.join("");
							}
							return c;
						},
						isBuffer: function (t) {
							return !(
								!t ||
								"object" != typeof t ||
								!(
									t.constructor &&
									t.constructor.isBuffer &&
									t.constructor.isBuffer(t)
								)
							);
						},
						isRegExp: function (t) {
							return "[object RegExp]" === Object.prototype.toString.call(t);
						},
						maybeMap: function (t, e) {
							if (i(t)) {
								for (var r = [], o = 0; o < t.length; o += 1) r.push(e(t[o]));
								return r;
							}
							return e(t);
						},
						merge: function t(e, r, o) {
							if (!r) return e;
							if ("object" != typeof r) {
								if (i(e)) e.push(r);
								else {
									if (!e || "object" != typeof e) return [e, r];
									((o && (o.plainObjects || o.allowPrototypes)) ||
										!n.call(Object.prototype, r)) &&
										(e[r] = !0);
								}
								return e;
							}
							if (!e || "object" != typeof e) return [e].concat(r);
							var a = e;
							return (
								i(e) && !i(r) && (a = s(e, o)),
								i(e) && i(r)
									? (r.forEach(function (r, i) {
											if (n.call(e, i)) {
												var a = e[i];
												a &&
												"object" == typeof a &&
												r &&
												"object" == typeof r
													? (e[i] = t(a, r, o))
													: e.push(r);
											} else e[i] = r;
										}),
										e)
									: Object.keys(r).reduce(function (e, i) {
											var a = r[i];
											return (
												n.call(e, i) ? (e[i] = t(e[i], a, o)) : (e[i] = a),
												e
											);
										}, a)
							);
						},
					};
				},
				259: (t, e, r) => {
					"use strict";
					var o = r(375),
						n = r(411),
						i = r(734)(),
						a = r(553),
						s = r(277),
						l = o("%Math.floor%");
					t.exports = function (t, e) {
						if ("function" != typeof t) throw new s("`fn` is not a function");
						if ("number" != typeof e || e < 0 || e > 4294967295 || l(e) !== e)
							throw new s("`length` must be a positive 32-bit integer");
						var r = arguments.length > 2 && !!arguments[2],
							o = !0,
							c = !0;
						if ("length" in t && a) {
							var p = a(t, "length");
							p && !p.configurable && (o = !1), p && !p.writable && (c = !1);
						}
						return (
							(o || c || !r) && (i ? n(t, "length", e, !0, !0) : n(t, "length", e)), t
						);
					};
				},
				670: (t, e, r) => {
					"use strict";
					var o = r(375),
						n = r(61),
						i = r(141),
						a = r(277),
						s = o("%WeakMap%", !0),
						l = o("%Map%", !0),
						c = n("WeakMap.prototype.get", !0),
						p = n("WeakMap.prototype.set", !0),
						u = n("WeakMap.prototype.has", !0),
						f = n("Map.prototype.get", !0),
						d = n("Map.prototype.set", !0),
						h = n("Map.prototype.has", !0),
						y = function (t, e) {
							for (var r, o = t; null !== (r = o.next); o = r)
								if (r.key === e)
									return (o.next = r.next), (r.next = t.next), (t.next = r), r;
						};
					t.exports = function () {
						var t,
							e,
							r,
							o = {
								assert: function (t) {
									if (!o.has(t))
										throw new a("Side channel does not contain " + i(t));
								},
								get: function (o) {
									if (
										s &&
										o &&
										("object" == typeof o || "function" == typeof o)
									) {
										if (t) return c(t, o);
									} else if (l) {
										if (e) return f(e, o);
									} else if (r)
										return (function (t, e) {
											var r = y(t, e);
											return r && r.value;
										})(r, o);
								},
								has: function (o) {
									if (
										s &&
										o &&
										("object" == typeof o || "function" == typeof o)
									) {
										if (t) return u(t, o);
									} else if (l) {
										if (e) return h(e, o);
									} else if (r)
										return (function (t, e) {
											return !!y(t, e);
										})(r, o);
									return !1;
								},
								set: function (o, n) {
									s && o && ("object" == typeof o || "function" == typeof o)
										? (t || (t = new s()), p(t, o, n))
										: l
											? (e || (e = new l()), d(e, o, n))
											: (r || (r = { key: {}, next: null }),
												(function (t, e, r) {
													var o = y(t, e);
													o
														? (o.value = r)
														: (t.next = {
																key: e,
																next: t.next,
																value: r,
															});
												})(r, o, n));
								},
							};
						return o;
					};
				},
				634: () => {},
				330: (t) => {
					"use strict";
					t.exports = JSON.parse(
						'{"name":"@sportdigi/bootstrapper","version":"11.2.2","description":"Gets everything ready for application start","main":"dist/bootstrapper.min.js","scripts":{"start":"webpack --config webpackDev.config.js && webpack-dev-server --config webpackDev.config.js","analyze":"webpack --config webpackDev.config.js && webpack-dev-server --config webpackDev.config.js --analyze","build:cdn":"sportdigi-scripts build","build":"sportdigi-scripts build","prepack":"npm run build","prepare":"husky install","format":"pretty-quick --staged"},"files":["dist"],"license":"ISC","devDependencies":{"@sportdigi/scripts":"5.7.6","ajv":"^8.17.1","husky":"^8.0.0","prettier":"^2.7.1","pretty-quick":"^3.1.3","webpack-bundle-analyzer":"^4.10.1","webpack-cli":"^5.0.1"},"browserslist":{"production":["Chrome >= 99","not dead","not op_mini all"],"development":["last 1 chrome version","last 1 firefox version","last 1 safari version"]},"dependencies":{"qs":"^6.11.2"}}'
					);
				},
			},
			e = {};
		function r(o) {
			var n = e[o];
			if (void 0 !== n) return n.exports;
			var i = (e[o] = { exports: {} });
			return t[o](i, i.exports, r), i.exports;
		}
		(r.m = t),
			(r.n = (t) => {
				var e = t && t.__esModule ? () => t.default : () => t;
				return r.d(e, { a: e }), e;
			}),
			(r.d = (t, e) => {
				for (var o in e)
					r.o(e, o) &&
						!r.o(t, o) &&
						Object.defineProperty(t, o, { enumerable: !0, get: e[o] });
			}),
			(r.f = {}),
			(r.e = (t) => Promise.all(Object.keys(r.f).reduce((e, o) => (r.f[o](t, e), e), []))),
			(r.u = (t) =>
				"jsChunks/" +
				t +
				"." +
				{ 166: "b5899bcc", 195: "df1041dc", 475: "e9d37a51", 769: "0debcb2d" }[t] +
				".chunk.js"),
			(r.miniCssF = (t) => {}),
			(r.g = (function () {
				if ("object" == typeof globalThis) return globalThis;
				try {
					return this || new Function("return this")();
				} catch (t) {
					if ("object" == typeof window) return window;
				}
			})()),
			(r.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e)),
			(() => {
				var t = {},
					e = "Bootstrapper:";
				r.l = (o, n, i, a) => {
					if (t[o]) t[o].push(n);
					else {
						var s, l;
						if (void 0 !== i)
							for (
								var c = document.getElementsByTagName("script"), p = 0;
								p < c.length;
								p++
							) {
								var u = c[p];
								if (
									u.getAttribute("src") == o ||
									u.getAttribute("data-webpack") == e + i
								) {
									s = u;
									break;
								}
							}
						s ||
							((l = !0),
							((s = document.createElement("script")).charset = "utf-8"),
							(s.timeout = 120),
							r.nc && s.setAttribute("nonce", r.nc),
							s.setAttribute("data-webpack", e + i),
							(s.src = o)),
							(t[o] = [n]);
						var f = (e, r) => {
								(s.onerror = s.onload = null), clearTimeout(d);
								var n = t[o];
								if (
									(delete t[o],
									s.parentNode && s.parentNode.removeChild(s),
									n && n.forEach((t) => t(r)),
									e)
								)
									return e(r);
							},
							d = setTimeout(
								f.bind(null, void 0, { type: "timeout", target: s }),
								12e4
							);
						(s.onerror = f.bind(null, s.onerror)),
							(s.onload = f.bind(null, s.onload)),
							l && document.head.appendChild(s);
					}
				};
			})(),
			(r.r = (t) => {
				"undefined" != typeof Symbol &&
					Symbol.toStringTag &&
					Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }),
					Object.defineProperty(t, "__esModule", { value: !0 });
			}),
			(() => {
				var t;
				r.g.importScripts && (t = r.g.location + "");
				var e = r.g.document;
				if (
					!t &&
					e &&
					(e.currentScript &&
						"SCRIPT" === e.currentScript.tagName.toUpperCase() &&
						(t = e.currentScript.src),
					!t)
				) {
					var o = e.getElementsByTagName("script");
					if (o.length)
						for (var n = o.length - 1; n > -1 && (!t || !/^http(s?):/.test(t)); )
							t = o[n--].src;
				}
				if (!t) throw new Error("Automatic publicPath is not supported in this browser");
				(t = t
					.replace(/#.*$/, "")
					.replace(/\?.*$/, "")
					.replace(/\/[^\/]+$/, "/")),
					(r.p = t);
			})(),
			(() => {
				var t = { 792: 0 };
				r.f.j = (e, o) => {
					var n = r.o(t, e) ? t[e] : void 0;
					if (0 !== n)
						if (n) o.push(n[2]);
						else {
							var i = new Promise((r, o) => (n = t[e] = [r, o]));
							o.push((n[2] = i));
							var a = r.p + r.u(e),
								s = new Error();
							r.l(
								a,
								(o) => {
									if (r.o(t, e) && (0 !== (n = t[e]) && (t[e] = void 0), n)) {
										var i = o && ("load" === o.type ? "missing" : o.type),
											a = o && o.target && o.target.src;
										(s.message =
											"Loading chunk " +
											e +
											" failed.\n(" +
											i +
											": " +
											a +
											")"),
											(s.name = "ChunkLoadError"),
											(s.type = i),
											(s.request = a),
											n[1](s);
									}
								},
								"chunk-" + e,
								e
							);
						}
				};
				var e = (e, o) => {
						var n,
							i,
							[a, s, l] = o,
							c = 0;
						if (a.some((e) => 0 !== t[e])) {
							for (n in s) r.o(s, n) && (r.m[n] = s[n]);
							l && l(r);
						}
						for (e && e(o); c < a.length; c++)
							(i = a[c]), r.o(t, i) && t[i] && t[i][0](), (t[i] = 0);
					},
					o = (this.webpackChunkBootstrapper = this.webpackChunkBootstrapper || []);
				o.forEach(e.bind(null, 0)), (o.push = e.bind(null, o.push.bind(o)));
			})();
		var o = {};
		return (
			(() => {
				"use strict";
				r.d(o, { default: () => b });
				var t = r(32);
				const e = {
					server: "",
					sportPartner: "",
					userTypeId: 2,
					isBetShop: !1,
					token: "-",
					timeZone: "",
					defaultLanguage: "",
					userId: "",
					globalSettings: null,
					requestFrame: null,
					translations: null,
					initialized: !1,
					resolved: !1,
					parent: [],
				};
				async function n(r, o = {}) {
					!(function (t = {}) {
						Object.entries(t).forEach(([t, r]) => {
							e.hasOwnProperty(t) && (e[t] = r);
						}),
							e.isBetShop && (e.userTypeId = 7),
							(e.defaultLanguage = ["language", "defaultLanguage", "l", "lang"]
								.map((e) => t[e])
								.find(Boolean));
						let r = e.server;
						r &&
							(r.endsWith("/") && (r = r.slice(0, -1)),
							r.includes("//") && (r = r.split("//")[1]),
							(e.server = `https://${r}`),
							(e.initialized = !0));
					})(r),
						await (async function (r, o) {
							t.S_.includes(o && o.name) && i(),
								await (async function () {
									const {
										userTypeId: t,
										server: r,
										sportPartner: o,
										parent: n,
									} = e;
									let i = "request-frame",
										a = document.getElementById(i);
									if (!a) {
										(a = document.createElement("iframe")),
											(a.id = i),
											(a.style.display = "none");
										let e = `${r}/Tools/RequestHelper`;
										o && (e = `${r}/${o}/Tools/RequestHelper`);
										let l = "?";
										Array.isArray(n) &&
											n.length > 0 &&
											n.map((t) => {
												(e = `${e}${l}parent=${t}`), "?" === l && (l = "&");
											}),
											(e = `${e}${l}userTypeId=${t}`),
											(a.src = e),
											await new Promise((t) => {
												["complete", "loaded", "interactive"].includes(
													document.readyState
												)
													? s(a, t)
													: document.addEventListener(
															"DOMContentLoaded",
															() => {
																s(a, t);
															}
														);
											});
									}
									return (
										e.requestFrame || (e.requestFrame = a), Promise.resolve()
									);
								})();
							let { resolved: n, token: a } = e;
							n ||
								(await (async function () {
									const { defaultLanguage: t, userTypeId: r, parent: o } = e;
									let n = {
										sender: "http-api",
										url: "/StaticContent/GlobalSettings.js",
										finalParams: {
											data: { l: t, userTypeId: r, parent: o },
											path: "StaticContent/GlobalSettings.js",
											method: "get",
											params: [
												["l", "string"],
												["parent", "string[]"],
												["userTypeId", "byte?"],
											],
										},
									};
									await l(n).then((t) => {
										e.globalSettings = t;
									});
								})(),
								a &&
									"-" !== a &&
									(await (async function () {
										const {
											userId: t,
											token: r,
											defaultLanguage: o,
											timeZone: n,
											userTypeId: i,
										} = e;
										let a = {
											sender: "http-api",
											url: "/Account/Authorize",
											finalParams: {
												data: {
													partnerUserId: t,
													token: r,
													l: o,
													tz: n,
													userTypeId: i,
												},
												path: "Account/Authorize",
												method: "get",
												params: [
													["partnerUserId", "long?"],
													["userTypeId", "byte?"],
													["token", "string"],
													["l", "string"],
													["tz", "double"],
												],
											},
										};
										await l(a).then((t) => {
											e.globalSettings = { ...e.globalSettings, ...t };
										});
									})()),
								await (async function () {
									const {
										globalSettings: { partner: t = {}, language: r = {} },
									} = e;
									let o = {
										sender: "http-api",
										url: "/StaticContent/Translations.js",
										finalParams: {
											data: { language: r.TwoLetterName, partnerId: t.Id },
											path: "StaticContent/Translations.js",
											method: "get",
											params: [
												["language", "string"],
												["partnerId", "int?"],
											],
										},
									};
									await l(o).then((t) => {
										e.translations = t;
									});
								})()),
								(e.resolved = !0);
						})(0, o),
						(r.token = "-"),
						(r.server = e.server),
						(r.globalSettings = e.globalSettings),
						(r.translations = e.translations);
				}
				function i(t = !1) {
					if (!e.initialized) return;
					const { server: r, sportPartner: o } = e;
					let n = `${r}/Error/Check`;
					if ((o && (n = `${r}/${o.toLowerCase()}/Error/Check`), t)) return a(r);
					let i = sessionStorage.getItem("__sb_err_cnt__");
					(i = parseInt(i)),
						isNaN(i) && (i = 0),
						i < 3 &&
							fetch(n, { method: "GET", mode: "cors", credentials: "include" })
								.then((t) => {
									var e, o;
									const n =
										null == t ||
										null === (e = t.headers) ||
										void 0 === e ||
										null === (o = e.get) ||
										void 0 === o
											? void 0
											: o.call(e, "server");
									(n && "cloudflare" !== n) ||
										403 !== t.status ||
										(sessionStorage.setItem("__sb_err_cnt__", ++i), a(r));
								})
								.catch(() => {
									sessionStorage.setItem("__sb_err_cnt__", ++i), a(r);
								});
				}
				function a(t) {
					return (location.href =
						t + "/Error/Validate?returnUrl=" + encodeURIComponent(location.href));
				}
				function s(t, e) {
					(t.onload = function () {
						(t.isSportFrameLoaded = !0), e();
					}),
						document.body.appendChild(t);
				}
				async function l(t = {}) {
					return (
						(t.messageId = t.url + Math.random()),
						(t.finalParams.headers = {}),
						new Promise((r, o) => {
							const n = t.messageId;
							let i = (t) => {
								t.data &&
									"object" == typeof t.data &&
									"http-api-response" === t.data.sender &&
									t.data.messageId === n &&
									(window.removeEventListener("message", i),
									t.data.ok || o(t.data),
									r(t.data.res));
							};
							window.addEventListener("message", i),
								e.requestFrame.contentWindow.postMessage(t, "*");
						})
					);
				}
				var c = r(215),
					p = r.n(c),
					u = r(644);
				class f {
					constructor(t) {
						this.initProps(), (this.postFix = t);
					}
					initProps() {
						(this.name = ""), (this.postFix = ""), (this.consoleTimeLabel = "");
					}
					timeEnd() {
						console.timeEnd(`${this.consoleTimeLabel}`);
					}
					time() {
						console.time(`${this.consoleTimeLabel}`);
					}
					initTimeLabel(t = this.name) {
						this.name = t;
						const e = this.postFix;
						this.consoleTimeLabel = `${t} ${e}`;
					}
				}
				class d extends f {
					constructor() {
						super("config extracting"), this.initProps();
					}
					reset() {
						this.initProps();
					}
					initProps() {
						(this.bootConfig = {}),
							(this.bootableConfig = {}),
							(this.name = null),
							(this.url = null),
							(this.urlWithVersion = null),
							(this.indexHTMLUrl = null),
							(this.indexHTML = null),
							(this.globalSettings = {}),
							(this.headElements = []),
							(this.bodyElements = []),
							(this.links = []),
							(this.scripts = []);
					}
					extract(t, e) {
						(this.bootConfig = e), (this.appConfig = t);
						const r = (this.name = e.name);
						return (
							(this.appName = (0, u.kW)(r)), this.init(t.server, e.isSpBranchVersion)
						);
					}
					async init(t, e) {
						return (
							this.initServer(t),
							this.initGlobalSettings(),
							this.initName(),
							this.initTimeLabel(),
							this.time(),
							this.initGlobalSettingsEnv(),
							this.initUrlWithVersion(e),
							await this.initElements(),
							this.initConfig(),
							this.timeEnd(),
							this.bootableConfig || {}
						);
					}
					initConfig() {
						this.bootableConfig = {
							name: this.name,
							links: this.links,
							scripts: this.scripts,
							indexHTML: this.indexHTML,
							globalSettings: this.globalSettings,
							html: { head: this.headElements, body: this.bodyElements },
							urls: {
								base: this.url,
								index: this.indexHTMLUrl,
								version: this.urlWithVersion,
							},
						};
					}
					async initElements() {
						const { urlWithVersion: t, appName: e } = this,
							r = `${t}/${e}.min.css`,
							o = `${t}/${e}.min.js`,
							n = document.createElement("link");
						(n.href = r), (n.rel = "stylesheet");
						const i = document.createElement("script");
						i.src = o;
						const a = [n],
							s = [i];
						this.assignToThis({
							headElements: a,
							bodyElements: s,
							links: a,
							scripts: s,
						});
					}
					initGlobalSettings() {
						const { globalSettings: t } = this.appConfig;
						this.globalSettings = t;
					}
					initUrlWithVersion(t) {
						const { partner: e, projects: r } = this.globalSettings,
							{ SpBranchDomainName: o, CdnDomainName: n } = e;
						let i = `https://${t ? o : n}/${this.appName}`,
							a = this.bootConfig.version || r[this.appName],
							s = a ? `${i}/${a}` : i;
						this.assignToThis({ url: i, urlWithVersion: s });
					}
					initGlobalSettingsEnv() {
						let t = this.globalSettings,
							e = t.Env || (t.partner || {}).Env;
						this.assignToThis({ globalSettingsEnv: e });
					}
					initName() {
						let t = this.bootConfig.name;
						this.assignToThis({ name: t });
					}
					initServer(t) {
						this.server = t;
					}
					assignToThis(t) {
						Object.assign(this, t);
					}
					destroy() {
						this.initProps();
					}
				}
				class h extends f {
					constructor() {
						super("loading"), this.initProps();
					}
					initProps() {
						super.initProps(),
							(this.name = ""),
							(this.debug = !1),
							(this.loadableElements = []),
							(this.loadingDone = !1),
							(this.onLoadResolve = u.lQ),
							(this.onLoadComplete = () => {
								(this.loadingDone = !0), this.timeEnd(), this.onLoadResolve(this);
							}),
							(this.bootableConfig = null);
					}
					async load(t) {
						return (
							(this.name = t.name),
							(this.debug = t.debug),
							this.initTimeLabel(),
							this.time(),
							(this.bootableConfig = t),
							(this.loadingDone = !1),
							this.initLoadableElements(),
							new Promise((t, e) => {
								this.onLoadResolve = t;
								try {
									this.loadElements();
								} catch (t) {
									e(t);
								}
							})
						);
					}
					loadElements() {
						this.loadLinks(), this.loadScriptsSync();
					}
					loadScriptsSync(t = this.bootableConfig.scripts) {
						let e = t[0];
						this.loadScriptNext(e, t);
					}
					loadScriptNext(t, e = this.bootableConfig.scripts, r = 0) {
						if (!t) return this.onLoadComplete();
						(t.onload = () => {
							this.debug && console.timeEnd(`script ${r}`),
								this.loadScriptNext(e[++r], e, r);
						}),
							this.addScriptToDocument(t),
							this.debug && console.time(`script ${r}`),
							this.callScriptOnloadManuallyIfIsNotLoadable(t);
					}
					callScriptOnloadManuallyIfIsNotLoadable(t) {
						!this.loadableElements.includes(t) && t.onload();
					}
					addScriptToDocument(t) {
						if (!(t instanceof HTMLElement)) return;
						let e = this.bootableConfig.html.head.includes(t) ? "head" : "body";
						document.querySelector(e).appendChild(t);
					}
					removeScripts() {
						((this.bootableConfig || {}).scripts || []).forEach((t) => t.remove());
					}
					loadLinks() {
						const t = document.head;
						this.bootableConfig.links.forEach((e) => t.insertBefore(e, t.firstChild));
					}
					removeLinks() {
						((this.bootableConfig || {}).links || []).forEach((t) => t.remove());
					}
					initLoadableElements() {
						let t = this.bootableConfig.scripts.filter((t) => t.src);
						this.loadableElements = t;
					}
					destroy() {
						this.removeLinks(), this.removeScripts(), this.initProps();
					}
				}
				class y {
					constructor() {
						this.initProps();
					}
					async start() {
						return (
							await this.callApplicationStartFunction(),
							this.afterLoadFunctions.forEach(Function.prototype.call),
							this
						);
					}
					async setConfig(t) {
						this.initProps(),
							(this.parent = t),
							(this.afterLoadFunctions = []),
							(this.appConfig = t.appConfig),
							(this.bootConfig = t.bootConfig),
							this.init(),
							await this.callApplicationSetConfigFunction();
					}
					get iframe() {
						return this.parent.iframe;
					}
					initProps() {
						(this.parent = {}),
							(this.afterLoadFunctions = []),
							(this.appConfig = {}),
							(this.bootConfig = {}),
							(this.appStarterImplemented = !1),
							(this.hostObject = {}),
							(this.appStarter = {});
					}
					addEventListener(t, e) {
						const r = this,
							o = this.iframe,
							n = this.bootConfig.name.toLowerCase();
						function i(o) {
							if (!r.iframe) return window.removeEventListener("message", i);
							const a = o.data,
								s = a.sender && a.sender !== n;
							a.type !== t ||
								s ||
								(r.iframe.contentWindow &&
									r.iframe.contentWindow.postMessage(o.data, "*"),
								e(a));
						}
						return (
							o
								? window.addEventListener("message", i)
								: this.callAppStarterMethod(() =>
										this.appStarter.addEventListener(t, e)
									),
							() => this.removeEventListener(t, i)
						);
					}
					removeEventListener(t, e) {
						const r = this.iframe;
						r
							? r.removeEventListener(t, e)
							: this.callAppStarterMethod(() =>
									this.appStarter.removeEventListener(t, e)
								);
					}
					dispatchEvent(t, e) {
						const r = this.iframe;
						if (!this.bootConfig.name) return;
						const o = this.bootConfig.name.toLowerCase();
						if (r) {
							const n = r.contentWindow;
							n &&
								n.postMessage(
									{ data: e, sender: "bootstrapper", receiver: o, type: t },
									"*"
								);
						} else this.callAppStarterMethod(() => this.appStarter.dispatchEvent(t, e));
					}
					callAppStarterMethod(t) {
						void 0 === this.appStarterImplemented
							? this.afterLoadFunctions.push(t)
							: this.appStarterImplemented
								? t()
								: console.warn(
										"%cAppStarter is not implemented. For messaging system please implement `@sportdigi/app-starter` in your application.",
										"color: orange"
									);
					}
					async callApplicationStartFunction() {
						return await this.callApplicationMethod("start");
					}
					async callApplicationSetConfigFunction() {
						return await this.callApplicationMethod("setConfig");
					}
					async callApplicationMethod(t) {
						let e = this.parent,
							r = this.appConfig,
							o = this.appStarter;
						if (!o[t])
							return this.bootConfig.debug && console.warn(t, "not found in", o);
						const n = Object.assign(r, { container: r.containerId });
						return o[t](n, e);
					}
					init() {
						this.initHostObject(),
							this.initAppStarter(),
							this.guessAppStarterIfNotFound(),
							this.guessAppDestroyIfNotFound();
					}
					initHostObject() {
						this.hostObject = this.iframe ? this.iframe.contentWindow : window;
					}
					initAppStarter() {
						const t = this.hostObject,
							e = this.bootConfig.name,
							r = (0, u.kW)(e),
							o = t.sportdigi;
						if (o) {
							const t = o[r];
							if (t) {
								if (t.addEventListener)
									return (this.appStarterImplemented = !0), (this.appStarter = t);
								this.appStarterImplemented = !1;
							}
						}
						const n = e || "",
							i = (0, u.e9)(t, n) || u.lQ;
						this.appStarter = { start: i };
					}
					guessAppStarterIfNotFound() {
						const t = this.appStarter.start,
							e = this.bootConfig.name,
							r = this.hostObject,
							o = this.bootConfig.appStarterName;
						if (t !== u.lQ || o) return;
						const n = (0, u.kW)(e);
						this.appStarter = (0, u.fn)(r, `sportdigi.${n}`) || {
							start: function () {
								console.log(
									"App starter function not found. Try to set parameter `appStarterName`"
								);
							},
						};
					}
					guessAppDestroyIfNotFound() {
						const t = this.appStarter.destroy,
							e = this.hostObject,
							r = this.bootConfig.name;
						if (t !== u.lQ) return;
						const o = (0, u.kW)(r);
						this.appStarter.destroy =
							(0, u.fn)(e, "AppStarter.destroy") ||
							(0, u.fn)(e, `DIGI.${r}.destroy`) ||
							(0, u.fn)(e, `sportdigi.${o}.destroy`) ||
							function () {
								console.log("App starter destroy function not found.");
							};
					}
					destroy() {
						this.appStarter.destroy && this.appStarter.destroy(), this.initProps();
					}
				}
				const m = (t, e) => {
					let r = "";
					for (let o = 0; o < t; o++)
						r += `<div class="skeleton-loader" style="height:${e}px"></div>`;
					return r;
				};
				window.spShadow || (window.spShadow = { config: {}, hashId: null }),
					window.dataLayer || (window.dataLayer = []);
				let g = window.Bootstrapper;
				g ||
					(g = class {
						constructor(t = {}) {
							this.init.apply(this, arguments);
						}
						static get version() {
							return r(330).version;
						}
						static async bootBetSlip(t, e = {}) {
							return (e.name = "Betslip"), g.bootIframe(t, e);
						}
						static createMultiBootEventToBehavior({ eventTo: t, data: e }) {
							const r = typeof t,
								o = "string" === r,
								n = "function" === r;
							return (r) => (o ? r.dispatch(t, e) : n ? t(r, e) : null);
						}
						static async setup() {
							return g.createInstanceAndCall("setup", arguments);
						}
						static async createBaseInstance({
							appConfig: r,
							convertedBootConfig: o,
							isBootIframe: n,
							iframeConfig: i,
						}) {
							if (t.ml.includes(o.name)) return g.bootWebComponent(r, o);
							const a = await this.getCustomBootFunction(r, o);
							return (
								n && (r.requestFrame = e.requestFrame),
								a
									? await a(r, { ...o, method: n ? "bootIframe" : "boot" })
									: n
										? await g.bootIframeBase(r, o, i)
										: await g.bootBase(r, o)
							);
						}
						static async boot(t, e) {
							const r = p().parse(location.search, { ignoreQueryPrefix: !0 }),
								o = g.initVersionControl(r, e);
							this.validateBootConfig(o),
								await g.initSettings(t, o),
								g.setEsportType(o, t);
							let n = await g.createBaseInstance({
								appConfig: t,
								convertedBootConfig: o,
							});
							return await g.initMaintenance(t, o, n), n;
						}
						static initVersionControl(e, r) {
							var o, n;
							return null !== (o = e[t.x3]) &&
								void 0 !== o &&
								o.startsWith(t.sM) &&
								r.name !== t.BP
								? { ...r, version: e[t.x3], isSpBranchVersion: !0 }
								: null !== (n = e[t.Ao]) &&
									  void 0 !== n &&
									  n.startsWith(t.sM) &&
									  r.name === t.BP
									? { ...r, version: e[t.Ao], isSpBranchVersion: !0 }
									: r;
						}
						static async initMaintenance(e, r, o) {
							if (t.S_.includes(r.name)) return await g.bootMaintenance(e, o);
						}
						static async initSettings(t, e) {
							let { name: r } = e;
							t.globalSettings ||
								((t.isBetShop = "BetShop" === r),
								await n(t, e),
								(e.newBetSlip = !t.globalSettings.partner.EnableOldBetSlip)),
								"Mobile" === r && "e-sport" === t.view && (e.name = "ESport"),
								"Mobile" === r &&
									"esport-view" === t.view &&
									(e.name = "EsportView");
						}
						static async bootBase(t, e) {
							return g.createInstanceAndCall("boot", arguments);
						}
						static async bootIframe(t, e, r = {}) {
							t.hashRouterDisabled = !0;
							const o = p().parse(location.search, { ignoreQueryPrefix: !0 }),
								n = g.initVersionControl(o, e);
							await g.initSettings(t, n), g.setEsportType(n, t);
							let i = await g.createBaseInstance({
								appConfig: t,
								convertedBootConfig: n,
								iframeConfig: r,
								isBootIframe: !0,
							});
							return await g.initMaintenance(t, n, i), i;
						}
						static validateBootConfig(t) {
							if ("Betslip" === t.name) {
								const e = `${t.name} project should be boot with bootIframe.`;
								throw new Error(e);
							}
						}
						static setEsportType(t, e) {
							e.globalSettings.partner.EnableNewEsport &&
								"ESport" === t.name &&
								(t.name = "EsportView");
						}
						static async getCustomBootFunction(t, e) {
							switch (e.name) {
								case "ESport":
									return (
										e.newBetSlip &&
										(await r.e(475).then(r.bind(r, 475))).default(g)
									);
								case "EsportView":
									return (
										t.globalSettings.projects["esport-view"].startsWith(
											"1.5.66"
										) && (await r.e(166).then(r.bind(r, 166))).default(g)
									);
								case "Betslip":
									return (await r.e(195).then(r.bind(r, 195))).default(g);
								case "BetShop":
									return (await r.e(769).then(r.bind(r, 769))).default(g);
								default:
									return null;
							}
						}
						static async bootWebComponentBase() {
							return g.createInstanceAndCall("bootWebComponent", arguments);
						}
						static async bootIframeBase() {
							return g.createInstanceAndCall("bootIframe", arguments);
						}
						static async createInstanceAndCall(e, r) {
							const o = new g();
							return (
								await o[e].apply(o, r),
								o.starter.addEventListener("onHttpCallError", (e) => {
									e.data &&
										403 === e.data.status &&
										t.S_.includes(r && r[1] && r[1].name) &&
										i(!0);
								}),
								o
							);
						}
						static async multiBoot(r, o, i) {
							return r.apps.every(({ bootConfig: e }) => t._v.includes(e.name))
								? (async function (t, e) {
										const r = {};
										e.apps.forEach(({ appConfig: t, bootConfig: e }) => {
											const o = `sport-${(0, u.kW)(t.type || e.name)}`;
											customElements.get(o) ||
												customElements.define(
													o,
													class extends HTMLElement {
														constructor() {
															super(),
																this.attachShadow({ mode: "open" });
															const t = document.createElement("div");
															(t.id = o),
																this.shadowRoot.append(t),
																(this.shadowRoot.rootElement = t);
														}
													}
												);
											let n = document.querySelector(o);
											if (!n) {
												const e = document.getElementById(t.containerId);
												(n = document.createElement(o)), e.append(n);
											}
											r[o] = {
												...t,
												webComponent: n,
												shadowRoot: n.shadowRoot,
												target: n.shadowRoot.rootElement,
												tagName: o,
											};
										});
										const o = { ...e, isLandingWidgets: !0, projects: r };
										return (
											(o.modalRoot = t.createModalRoot()),
											(o.betslipRoot = t.createBetslipRoot()),
											t.boot(o, { name: "LandingWidgets" })
										);
									})(g, r)
								: new Promise(async (a) => {
										let { server: s, apps: l = [], communication: c = [] } = r;
										r.globalSettings ||
											((r.isBetShop = "BetShop" === o),
											await n(r, { name: o }),
											r.apps.forEach((t) => {
												t.bootConfig.newBetSlip =
													!e.globalSettings.partner.EnableOldBetSlip;
											})),
											(r.appViewName = r.view === t.tn ? t.Qe : o);
										const p = {},
											f = {},
											d = {};
										let h = 0;
										l.forEach((t) => {
											const {
													appConfig: e,
													bootConfig: n,
													iframeConfig: y,
													method: m,
													instanceName: b,
												} = t,
												v = Object.assign({ server: s }, r, e),
												w = g[m](v, n, y),
												S = n.name;
											w.then((t) => {
												(p[b || S] = t),
													c.forEach((e) => {
														const {
															from: r,
															eventFrom: o,
															to: n,
															eventTo: i,
														} = e;
														r === S &&
															t.addEventListener(o, (e) => {
																const { data: o } = e;
																f[r] &&
																	(f[r].forEach((e) => e(t)),
																	(f[r] = []));
																const a =
																	g.createMultiBootEventToBehavior(
																		{ eventTo: i, data: o }
																	);
																p[n]
																	? a(p[n])
																	: (f[n] || (f[n] = []),
																		f[n].push(a));
															});
													}),
													d[S] &&
														d[S].forEach(({ callback: e, data: r }) => {
															e(t, r);
														}),
													l.forEach((e) => {
														const r = (e.listen || {})[S];
														r &&
															Object.entries(r).map(([r, o]) => {
																const n =
																	e.instanceName ||
																	e.bootConfig.name;
																t.addEventListener(r, (t) => {
																	p[n]
																		? o(p[n], t)
																		: (d[n] || (d[n] = []),
																			d[n].push({
																				callback: o,
																				data: t,
																			}));
																});
															});
													});
											}).then(() => {
												if ((h++, l.length === h)) {
													const t = (0, u.aR)(p, o, i);
													a(t);
												}
											});
										});
									});
						}
						initHeaderElement() {
							const t = (this.iframeConfig || {}).headerElement || {},
								e = t.clientHeight || 0;
							(this.headerElement = t), (this.headerHeight = e);
						}
						reset() {
							this.destroy();
						}
						initProps() {
							(this.bootConfig = null),
								(this.appConfig = {}),
								(this.appBootableConfig = {}),
								(this.headerElement = null),
								(this.headerHeight = null),
								(this.iframeConfig = {}),
								(this.removeScrollListener = Function.prototype),
								(this.socket = {});
						}
						async bootIframe(t, e, r = {}) {
							return (
								await this.configure(t, e, r),
								this.initHeaderElement(),
								this.setupIframeHeightAsNum(),
								await this.createIframe({ scriptUrls: t.scriptUrls || [] }),
								await this.setConfig(),
								await this.start(),
								this.startMessaging(),
								this
							);
						}
						async bootWebComponent(e = {}, r = {}) {
							return (
								(e.isIframe = !1),
								t.iK.includes(r.name) &&
									((e.modalRoot = g.createModalRoot()),
									(e.betslipRoot = g.createBetslipRoot())),
								this.destroy(),
								await this.configure(e, r),
								await this.load(),
								await this.setConfig(),
								await this.start(),
								this.startMessaging(),
								this
							);
						}
						static createModalRoot() {
							customElements.get("sport-modal") ||
								customElements.define(
									"sport-modal",
									class extends HTMLElement {
										constructor() {
											super(),
												this.attachShadow({ mode: "open" }),
												(this.root = document.createElement("div")),
												this.shadowRoot.append(this.root);
										}
									}
								);
							let t = document.querySelector("sport-modal");
							if (!t) {
								const e = document.createElement("div");
								(t = document.createElement("sport-modal")),
									(e.style.position = "relative"),
									(e.style.zIndex = "100000000"),
									(e.className = "bootstrapper_modal_wrapper"),
									e.append(t),
									document.body.append(e);
							}
							return t;
						}
						static createBetslipRoot() {
							customElements.get("sport-betslip") ||
								customElements.define(
									"sport-betslip",
									class extends HTMLElement {
										constructor() {
											super(),
												this.attachShadow({ mode: "open" }),
												(this.root = document.createElement("div")),
												this.shadowRoot.append(this.root);
										}
									}
								);
							let t = document.querySelector("sport-betslip");
							return (
								t ||
									((t = document.createElement("sport-betslip")),
									document.body.append(t)),
								t
							);
						}
						async createIframe(t = {}) {
							const {
									htmlTagAttrs: e = "",
									containerAttrs: r = "",
									scriptUrls: o = [],
								} = t,
								n = {
									width: "100%",
									height: "1000px",
									frameborder: "0",
									allowfullscreen: "",
									allow: "autoplay",
									scrolling: "no",
								},
								i = this.appConfig,
								a = this.bootConfig,
								s = this.iframeConfig,
								l = this.configExtractor,
								c = i.containerId,
								p = a.name,
								f = l.links,
								d = l.scripts;
							o.length &&
								o.forEach((t) => {
									const e = document.createElement("script");
									(e.src = t), d.push(e);
								});
							const h = `\n            <!DOCTYPE html>\n            <html ${e} data-theme lang='en'>\n                <head>\n                <title>${p}</title>\n                    ${f
								.map((t) => t.outerHTML)
								.join(
									""
								)}\n                </head>        \n                \n                <body>\n                    <div ${r} id='${c}'></div>                \n                    <div id='modals'></div>\n                    ${d
								.map((t) => t.outerHTML)
								.join("")}\n                </body>\n            </html>\n        `;
							(["AsianView", "Mobile"].includes(p) || s.height) && delete n.scrolling;
							const y = document.createElement("iframe"),
								m = Object.assign({}, n, s);
							Object.entries(m).forEach(([t, e]) => y.setAttribute(t, e)),
								Object.assign(y.style, {
									width: 0,
									"min-width": "100%",
									"min-height": "",
									opacity: 0,
									display: "block",
								});
							const g = document.getElementById(c) || document.createElement("div");
							if (!g)
								return console.warn(
									`Provided container id "${c}" is not in the DOM`
								);
							const b = g.style.height;
							let v;
							if ((b && (y.height = y.style.height = b), (0, u.nr)())) {
								console.log("Safari detected"), g.appendChild(y);
								const t = y.contentDocument;
								t.open(),
									t.write(h),
									(v = new Promise((e) => {
										t.addEventListener("DOMContentLoaded", function r() {
											t.removeEventListener("DOMContentLoaded", r), e();
										});
									})),
									t.close();
							} else
								(y.srcdoc = h),
									g.appendChild(y),
									(v = new Promise((t) => (y.onload = t)));
							await v,
								(y.style.opacity = "1"),
								(this.iframe = y),
								(this.iframeContainer = g),
								(this.appConfig.isIframe = !0),
								(this.appConfig.iframe = y);
						}
						async boot(t = {}, e = {}) {
							return (
								(t.isIframe = !1),
								this.destroy(),
								await this.configure(t, e),
								await this.load(),
								await this.setConfig(),
								await this.start(),
								this.startMessaging(),
								this
							);
						}
						startMessaging() {
							this.dynamicallyChangeIframeDimensions(),
								this.dispatchParentBoundingBoxOnScroll();
						}
						navigateTo(t) {
							this.dispatch("navigateTo", t);
						}
						dispatchParentBoundingBoxOnScroll() {
							if (!this.iframe) return;
							const t = () => this.dispatchParentBoundingBox();
							window.addEventListener("scroll", t),
								(this.removeScrollListener = () =>
									window.removeEventListener("scroll", t));
						}
						dispatchParentBoundingBox() {
							const t = this.getBoundingBoxes();
							this.dispatch("bounds", { bounds: t });
						}
						getBoundingBoxes() {
							const t = this.iframe,
								e = this.headerHeight,
								r = document.documentElement.getBoundingClientRect(),
								o = t.getBoundingClientRect();
							return {
								visibleArea: {
									bottom: r.bottom,
									height: r.height,
									left: r.left,
									right: r.right,
									top: r.top,
									width: r.width,
									x: r.x,
									y: r.y,
									windowInnerHeight: window.innerHeight,
								},
								sportIframe: {
									bottom: o.bottom,
									height: o.height,
									left: o.left,
									right: o.right,
									top: o.top,
									width: o.width,
									x: o.x,
									y: o.y,
								},
								headerHeight: e,
							};
						}
						dynamicallyChangeIframeDimensions() {
							this.iframe &&
								this.addEventListener("changeDimensions", (t) => {
									t.sender &&
										(this.setIframeHeightWithLimit(t.data),
										this.dispatchParentBoundingBox());
								});
						}
						setupIframeHeightAsNum() {
							const t = this.iframeConfig.height;
							if (!t) return;
							if ("number" == typeof t) return (this.iframeHeightAsNum = t);
							const e = `${t}`.match(/^[0-9]+/);
							this.iframeHeightAsNum = e && +e[0];
						}
						setupMobileIframeHeight() {
							var t;
							if (
								"Mobile" ===
									(null === (t = this.bootConfig) || void 0 === t
										? void 0
										: t.name) &&
								this.iframeConfig &&
								!this.iframeConfig.hasOwnProperty("height")
							) {
								var e;
								const t =
									null === (e = this.iframe) || void 0 === e
										? void 0
										: e.offsetTop;
								return window.innerHeight - t;
							}
						}
						setIframeHeightWithLimit(t) {
							const e = t.height,
								r = this.iframeHeightAsNum;
							let o = r > e ? r : e;
							(o = this.setupMobileIframeHeight() || o),
								this.setIframeHeight({ height: o });
						}
						setIframeHeight(t) {
							const e = this.iframe,
								r = t.height;
							+r && (e.height = r + "px");
						}
						changeColors(t) {
							this.dispatchColorsChange.apply(this, arguments);
						}
						dispatchColorsChange(t) {
							this.dispatch("changeColors", { colors: t });
						}
						async setup(t, e) {
							await this.configure(t, e), await this.load(), await this.setConfig();
						}
						async configure(t, e, r = {}) {
							return (
								(this.appConfig = t),
								(this.iframeConfig = r),
								((t) => {
									if ("Mobile" === t.appViewName) {
										let e = t.target;
										const r = `\n        <style>.skeleton-loader {\n        display: block;\n        background-color: rgba(255,255,255,0.3) !important;\n        animation-name: skeletonAnimation;\n        animation-duration: 1.5s;\n        animation-iteration-count: infinite;\n        animation-timing-function: linear;\n        margin-bottom: 5px;\n        height: 20px;\n        width: 100%\n        }\n        @keyframes skeletonAnimation {\n        0% {\n          opacity: 0.8;\n        }\n        50% {\n          opacity: 0.4;\n        }\n        100% {\n          opacity: 0.8;\n        }\n      }</style>\n         ${m(
											1,
											44
										)}\n         ${m(1, 46)}\n         ${m(
											1,
											41
										)}\n         ${m(1, 29)}\n         ${m(3, 111)}\n        `;
										e.innerHTML = r;
									}
								})(this.appConfig),
								this.initBootConfig(e),
								await g.initSettings(this.appConfig, this.bootConfig),
								await this.initAppBootableConfig(),
								this.finalizeAppConfig(),
								this.appBootableConfig
							);
						}
						async load() {
							return await this.loader.load(this.appBootableConfig), this;
						}
						start() {
							return this.starter.start(this);
						}
						setConfig() {
							return this.starter.setConfig(this);
						}
						init(t) {
							this.initDependencies(), this.initProps(t);
						}
						initDependencies() {
							(this.configExtractor = new d()),
								(this.loader = new h()),
								(this.starter = new y());
						}
						finalizeAppConfig() {
							const t = this.appConfig,
								{ version: e, urlWithVersion: r } = this.configExtractor;
							Object.assign(t, { publicPath: `${r}/`, version: e });
						}
						async initAppBootableConfig() {
							this.appBootableConfig = await this.configExtractor.extract(
								this.appConfig,
								this.bootConfig
							);
						}
						initBootConfig(t = {}) {
							if (!t.name)
								throw new Error(
									'Please provide application `name`, { name: "<APPLICATION NAME>" }'
								);
							this.bootConfig = t;
						}
						objToWindowOptions(t) {
							return JSON.stringify(t).replace(/["{}]/g, "").replace(/:/g, "=");
						}
						addEventListener(t, e) {
							return this.starter.addEventListener(t, e), this;
						}
						removeEventListener(t, e) {
							return this.starter.removeEventListener(t, e), this;
						}
						dispatch(t, e) {
							return this.starter.dispatchEvent(t, e), this;
						}
						destroy() {
							var t, r;
							(e.resolved = !1),
								this.removeScrollListener(),
								this.initProps(),
								this.loader.destroy(),
								this.starter.destroy(),
								this.configExtractor.destroy(),
								this.iframe && this.iframe.remove(),
								(this.iframe = null),
								null === (t = (r = this.socket).close) || void 0 === t || t.call(r);
						}
						static async bootWebComponent(t, e) {
							let r = document.getElementById(t.containerId);
							!r &&
								t.target &&
								(t.target instanceof HTMLElement
									? (r = t.target)
									: ((t.containerId = t.target.replace("#", "")),
										(r = document.getElementById(t.containerId))));
							const o = `sport-${(0, u.kW)(e.name)}`,
								n = (0, u.W7)();
							window.spShadow.config[n] = { appConfig: t, hash: n, tagName: o };
							let i = window.spShadow.config[n];
							(window.spShadow.hashId = n),
								customElements.get(o) ||
									customElements.define(
										o,
										class extends HTMLElement {
											constructor() {
												super(), this.attachShadow({ mode: "open" });
												const t = document.createElement("div");
												let e =
													window.spShadow.config[window.spShadow.hashId];
												(t.id = e.tagName),
													this.shadowRoot.append(t),
													(e.appConfig.shadowRoot = this.shadowRoot),
													(e.appConfig.containerId = null),
													(e.appConfig.target = t);
											}
										}
									);
							let a = document.createElement(o);
							(t = { ...i.appConfig, webComponent: a }),
								r && r.append(a),
								this.validateBootConfig(e),
								await g.initSettings(t, e);
							const s = await this.getCustomBootFunction(t, e);
							if (s)
								return s(t, { ...e, method: "bootWebComponent" }).then(
									(t) => (
										t.configExtractor.links.forEach((e) => {
											t.appConfig.shadowRoot.prepend(e),
												t.appConfig.modalRoot &&
													(t.appConfig.modalRoot.shadowRoot.prepend(
														e.cloneNode(!0)
													),
													t.appConfig.betslipRoot.shadowRoot.prepend(
														e.cloneNode(!0)
													));
										}),
										t
									)
								);
							const l = await g.bootWebComponentBase(t, e);
							return (
								l.configExtractor.links.forEach((e) => {
									t.shadowRoot.prepend(e),
										t.isLandingWidgets &&
											Object.values(i.appConfig.projects).forEach(
												({ shadowRoot: t }) => {
													t.prepend(e.cloneNode(!0));
												}
											),
										t.modalRoot &&
											(t.modalRoot.shadowRoot.prepend(e.cloneNode(!0)),
											t.betslipRoot.shadowRoot.prepend(e.cloneNode(!0)));
								}),
								l
							);
						}
						static async bootMaintenance(e, r) {
							var o, n;
							if (
								null === (o = e.globalSettings) ||
								void 0 === o ||
								null === (n = o.publicApis) ||
								void 0 === n ||
								!n.HealthCheckUrlSocket
							)
								return;
							const i = e.sportPartner ? `&systemRID=${e.sportPartner}` : "",
								a = `${e.globalSettings.publicApis.HealthCheckUrlSocket}${i}`;
							(r.socket = new WebSocket(a)),
								(r.socket.onmessage = async function (o) {
									if ("false" !== o.data) {
										const o = document.getElementById("jackpotHiddenContainer");
										setTimeout(() => {
											o && o.remove();
										}, 100),
											null == r || r.destroy();
										let n = document.getElementById(e.containerId);
										if (this.maintenanceIframe && n)
											n.appendChild(this.maintenanceIframe);
										else {
											const r = `${e.server}${t.B0}`;
											this.maintenanceIframe = await g.bootMaintenanceIFrame(
												e,
												r
											);
										}
									} else
										this.maintenanceIframe &&
											(this.maintenanceIframe.remove(),
											(this.maintenanceIframe = null),
											location.reload());
									return this.maintenanceIframe;
								}),
								(r.socket.onerror = function (t) {
									console.log(t);
								});
						}
						static async bootMaintenanceIFrame(t, e) {
							var r, o;
							const n = {
									width: "100%",
									height: "1000px",
									frameborder: "0",
									allowfullscreen: "",
									allow: "autoplay",
									scrolling: "no",
									src: e,
								},
								i = document.createElement("iframe"),
								a = Object.assign({}, n);
							Object.entries(a).forEach(([t, e]) => i.setAttribute(t, e)),
								Object.assign(i.style, {
									display: "block",
									width: 0,
									opacity: 0,
									margin: 0,
									"min-height": "",
									"min-width": "100%",
								}),
								null !== (r = t.target) &&
									void 0 !== r &&
									null !== (o = r.style) &&
									void 0 !== o &&
									o.height &&
									(t.target.style.height = 0);
							const s =
								document.getElementById(t.containerId) ||
								t.shadowRoot ||
								document.createElement("div");
							return s
								? (s.appendChild(i), (i.style.opacity = "1"), i)
								: console.warn(
										`Provided container id "${t.containerId}" is not in the DOM`
									);
						}
					});
				const b = g;
			})(),
			o.default
		);
	})()
);
